export default {
  date: {
    formats: {
      default: '%d-%m-%Y',
      short: '%-d %B',
      long: '%-d %B, %Y',
      with_day: '%A, %-d %B',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    abbr_day_names: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    month_names: [
      null,
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    abbr_month_names: [
      null,
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    order: ['year', 'month', 'day'],
  },
  number: {
    format: {
      separator: '.',
      delimiter: ',',
      precision: 3,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%u%n',
        unit: '$',
        separator: '.',
        delimiter: ',',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'cad',
      AUD: 'aud',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: '',
        format: '%n%',
      },
    },
    precision: {
      format: {
        delimiter: '',
      },
    },
    human: {
      format: {
        delimiter: '',
        precision: 3,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: {
            one: 'Byte',
            other: 'Bytes',
          },
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: '',
          thousand: 'Thousand',
          million: 'Million',
          billion: 'Billion',
          trillion: 'Trillion',
          quadrillion: 'Quadrillion',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'half a minute',
      less_than_x_seconds: {
        one: 'less than 1 second',
        other: 'less than %{count} seconds',
        few: 'menos de %{count} segundos',
        many: 'menos de %{count} segundos',
      },
      x_seconds: {
        one: '1 second',
        other: '%{count} seconds',
        few: '%{count} segundos',
        many: '%{count} segundos',
      },
      less_than_x_minutes: {
        one: 'less than a minute',
        other: 'less than %{count} minutes',
        few: 'menos de %{count} minutos',
        many: 'menos de %{count} minutos',
      },
      x_minutes: {
        one: '1 minute',
        other: '%{count} minutes',
        few: '%{count} minutos',
        many: '%{count} minutos',
      },
      about_x_hours: {
        one: 'about 1 hour',
        other: 'about %{count} hours',
        few: 'cerca de %{count} horas',
        many: 'cerca de %{count} horas',
      },
      x_days: {
        one: '1 day',
        other: '%{count} days',
        few: '%{count} dias',
        many: '%{count} dias',
      },
      about_x_months: {
        one: 'about 1 month',
        other: 'about %{count} months',
        few: 'cerca de %{count} meses',
        many: 'cerca de %{count} meses',
      },
      x_months: {
        one: '1 month',
        other: '%{count} months',
        few: '%{count} meses',
        many: '%{count} meses',
      },
      about_x_years: {
        one: 'about 1 year',
        other: 'about %{count} years',
        few: 'cerca de %{count} anos',
        many: 'cerca de %{count} anos',
      },
      over_x_years: {
        one: 'over 1 year',
        other: 'over %{count} years',
        few: 'mais de %{count} anos',
        many: 'mais de %{count} anos',
      },
      almost_x_years: {
        one: 'almost 1 year',
        other: 'almost %{count} years',
        few: 'quase %{count} anos',
        many: 'quase %{count} anos',
      },
      x_years: {
        one: '1 ano',
        other: '%{count} anos',
      },
      x_weeks: {
        one: '1 week',
        other: '%{count} weeks',
        few: '%{count} semanas',
        many: '%{count} semanas',
      },
      x_hours: {
        one: '1 hora',
        other: '%{count} horas',
      },
    },
    prompts: {
      year: 'Year',
      month: 'Month',
      day: 'Day',
      hour: 'Hour',
      minute: 'Minute',
      second: 'Seconds',
    },
  },
  'custom-wallpaper': {
    'aria-title': 'Papel de parede',
    'aria-label': 'Definir papel de parede',
    'aria-author': 'autor:',
    set_custom_wallpaper: 'Definir papel de fundo personalizado',
    set_custom_wallpaper_description:
      'Coloque seu próprio papel de fundo na transferência para causar uma ótima impressão quando as pessoas baixarem seus arquivos. Não se preocupe, isso não mudará suas ',
    default_settings: 'configurações padrão',
    upload: 'Carregar',
    reset_default: 'Voltar para o padrão',
    survey_link: 'Conte-nos sua opinião',
    file_rules:
      'JPEG/PNG %{minWallpaperWidth}x%{minWallpaperHeight}, máximo de %{maxUploadSize} MB',
    storage_size_max: 'máximo',
    pop_over: {
      new_feature: 'Novo recurso',
      try_now: 'Experimente agora',
      not_today: 'Hoje não',
      hide_forever: 'Ocultar para sempre',
      hint: 'Ei, você pode colocar seu próprio papel de fundo em qualquer transferência sem alterar essas configurações. Basta definir um papel de fundo personalizado antes de enviar a transferência.',
      introductory_upsell:
        'Ei, agora você pode colocar seu próprio papel de fundo na transferência.',
    },
    curated_description: {
      one: 'Ilustração abstrata de potes e vasos em vários padrões coloridos, por Bernardo Henning',
      two: 'Ilustração abstrata de três potes e vasos em vários padrões coloridos, por Bernardo Henning',
      three: 'Fotografia de uma paisagem rural com montanhas, por Ana Cuba',
      four: 'Fotografia de uma paisagem rural com montanhas e água, por Ana Cuba',
      five: 'Ilustração de flores azuis em frente a um fundo roxo, por Hiroyuki Izutsu',
      six: 'Ilustração de ilhas ao anoitecer com um barco e um farol, por Hiroyuki Izutsu',
    },
    custom_description: 'Sua imagem personalizada',
    toggle_transfer_options: 'Alternar entre opções de transferência',
  },
  page: {
    plus: {
      button: {
        text: 'Fazer upgrade para o Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Até cinco imagens diferentes',
        best_2: 'JPEG ou PNG',
        best_3: 'Até %{size}',
        best_4: '%{resolution} pixels ou mais',
        best_5: 'GIFs ou vídeos não são aceitos (desculpe)',
        best_title: 'Informações importantes:',
        text: 'Destaque a si mesmo ou a sua marca com cinco fundos de tela ou imagens rotativos:',
        best_five: '%{videoResolution} pixels para vídeos',
        best_four: '%{resolution} pixels para imagens',
        best_one: 'Até cinco vídeos ou imagens',
        best_six:
          'As imagens de fundo mudam a cada %{rotationInterval} segundos, os vídeos mais longos do que %{rotationInterval} segundos serão encurtados',
        best_three: '%{size} máximo por vídeo/imagem',
        best_two: 'JPEG, PNG ou MP4',
        notice:
          "Rufem os tambores! Os fundos de tela com vídeo já chegaram! <a href='/profile'>Crie seu vídeo de fundo de tela agora</a>.",
      },
      upsell: {
        benefit_one_alt: 'Tenha sua própria página do WeTransfer',
        heading_alt: 'Entregue seu trabalho com estilo',
        benefit_one: 'Tenha seu próprio domínio no WeTransfer',
        benefit_three: 'Faça o design dos seus e-mails de transferência',
        benefit_two:
          'Tenha fundos personalizados durante o download dos arquivos',
        button: {
          action: 'Conte-me mais',
        },
        heading: 'Destaque sua marca com WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Envie o melhor.</strong> Cause uma excelente impressão sempre que as pessoas fizerem download dos seus arquivos.<br /> <strong>Receba com facilidade.</strong> Qualquer pessoa pode enviar arquivos para você como parte do seu plano.',
        protip: {
          text: '<strong>Dica de Pro:</strong> Vai solicitar uma transferência para alguém? Compartilhe um link especial para preencher previamente a descrição para a pessoa.',
          link: 'Saiba mais',
        },
      },
      pagename: 'Definições do perfil',
      'onboarding-step-two':
        "Apresente seus arquivos com estilo, personalize seu perfil no WeTransfer e admire seu novo look em <a href='%{href}'>%{domain}</a>",
      email_backgrounds: 'Personalize seus e-mails',
      sent_you_files: 'enviou alguns arquivos para você',
      email_background_instruction_with_spec:
        'Dê destaque aos seus e-mails de transferências com uma imagem de fundo. Para melhores resultados, utilize uma imagem de %{resolution} pixels (ou a cortaremos para caber). O tamanho máximo do arquivo é de %{size}.   ',
      receiving: 'E-mail do perfil',
      choose_wallpapers: 'Adicione seus fundos de tela',
      'step-one-banner':
        'Para começar, escolha um URL para a sua página do WeTransfer. Você poderá alterar sempre que quiser.',
      description: {
        pro: 'Com sua página do WeTransfer, você pode causar uma ótima impressão sempre que as pessoas fizerem download dos seus arquivos. E é aqui que qualquer pessoa pode enviar transferências de 200 GB para você, como parte do seu plano WeTransfer Pro.',
        premium:
          'Com a sua página do WeTransfer, você pode causar uma ótima impressão sempre que as pessoas fizerem download dos seus arquivos. E é aqui que qualquer pessoa pode enviar transferências para você, sem limite de tamanho de arquivo, como parte do plano WeTransfer Premium.',
      },
      'instructions-1': 'Altere seu nome e o URL sempre que precisar.',
      'instructions-2':
        'Depois que você escolher um novo URL, sua página será atualizada imediatamente.',
      title: 'Edite sua página',
      profile_url: 'URL do perfil',
    },
    payment: {
      never_actived_retry:
        'Sua conta ainda não está ativa. Conclua o cadastro para começar a utilizar o <a href="/payment/retry">%{planName}</a>',
      pagename: 'Plano e pagamento',
      autorenew_heading: 'Informações de pagamento',
      autorenew_notice:
        'Sua assinatura %{planName} do %{deal} será renovada automaticamente em %{autorenewal_attempt}.',
      will_expire_notice:
        "Sua assinatura Pro vai <span class='payment__notice'>expirar em %{daysBetween} dias</span>. Renove agora sua conta ou configure uma renovação automática.",
      never_actived_notice:
        'Sua conta ainda não está ativa. <a href="/payment/retry">Conclua o cadastro para começar a usar o Pro.</a>',
      manual_renewal_expiry_notice: 'Sua conta Pro vai expirar em %{expiry}.',
      to_checkout: 'Ir para a finalização da compra',
      updating: 'Atualizando...',
      yes_disable: 'Sim, continuar',
      review_billing_link: 'Atualizar a forma de pagamento?',
      autorenew_failed:
        "Sua assinatura Pro de %{deal}/%{period} vai <span class='payment__notice'><strong>expirar em %{daysBetween} dias</strong>. Não foi possível renovar sua conta – renove sua conta manualmente até <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew: 'Deseja cancelar a renovação automática?',
      disable_autorenewal: 'Cancelar renovação automática',
      enable_autorenewal: 'Ativar renovação automática',
      renew_now: 'Renovar agora',
      subscription_expired: 'Sua conta Pro expirou.',
      cancel_heading: 'Time to move on?',
      cancel_info:
        'We get it, these things happen. Once you cancel your subscription we’ll hold onto your files for another 30 days (no not under our pillow - don’t make it weird), in case there’s anything you’ve left behind. You can also reopen your subscription whenever you like.',
      cancel_info_subscription:
        'We get it, these things happen. Once you cancel your subscription, you’ll be able to use your Pro account until %{subscriptionExpiryDate}. After that we’ll hold onto your files for another 30 days (no not under our pillow - don’t make it weird), in case there’s anything you’ve left behind. You can also reopen your subscription whenever you like.',
      cancel_now: 'Cancelar assinatura',
      cancelling: 'Cancelando...',
      confirm_cancel_subscription: 'Deseja mesmo cancelar sua assinatura?',
      confirm_reactivate_subscription:
        'Excellent choice! Just one more click to reactivate your payment method',
      manual_renewal_in_future_notice:
        'Your Pro subscription of %{deal}/%{period} will expire in %{daysBetween} days. You can manually renew your account after %{manual_renewal_available_at}, or activate automatic renewal now.',
      reactivate_heading: 'Vamos começar de novo.',
      reactivate_content_top_pro:
        'You can reactivate your %{planName} subscription and it’ll be like you never cancelled. Or you can choose to upgrade to WeTransfer Premium:',
      reactivate_content_top_premium:
        'Você pode reativar sua assinatura %{planName} e será como se nunca tivesses cancelado.',
      reactivate_content_bottom_pro:
        'Se fizer o upgrade para Premium, serão cobrados %{upfront_payment} e você poderá começar imediatamente a utilizar o WeTransfer Premium. Sua nova assinatura de %{recurring_payment}/%{interval} será renovada em %{recurring_date}.',
      reactivate_pro: 'Reativar Pro',
      reactivate_premium: 'Reativar Premium',
      reactivate_upgrade_to_premium: 'Upgrade para Premium',
      reactivating: 'Reativando...',
      subscription_cancelled:
        'Sua assinatura foi cancelada e vai expirar automaticamente dentro de %{daysBetween} dias.',
      subscription_reactivate_expired_notice:
        'Your Pro account has been cancelled.',
      subscription_reactivate_notice_pro:
        'Sua assinatura %{planName} foi cancelada e terminará dentro de %{daysBetween} dias.',
      subscription_reactivate_notice_premium:
        'Sua assinatura %{planName} foi cancelada e terminará dentro de %{daysBetween} dias.\nMudou de ideia? Não entre em pânico, é fácil recuperar o funcionamento de tudo.',
      subscription_reactivate_notice_trial_before:
        'Sua assinatura do %{planName} foi cancelada e terminará em %{daysBetween} dias. Você pode continuar desfrutando do seu teste do WeTransfer Premium até o fim da assinatura.',
      subscription_reactivate_notice_trial_after:
        'Sua assinatura %{planName} foi cancelada e terminará dentro de %{daysBetween} dias.\nvocê pode continuar a desfrutar do teste do WeTransfer Premium até %{trialExpiryDate}.',
      update_method_link: 'Atualização dos dados de pagamento',
      autorenew_notice_teams:
        'Sua assinatura %{planName} de %{deal} será renovada automaticamente para sua equipe de %{number_of_members} membros em %{autorenewal_attempt}.',
      cancellation_cta: 'Cancelar assinatura',
      cancellation_heading: 'Não precisa mais das vantagens do %{planName}?',
      cancellation_heading_trial: 'Cancelar assinatura',
      cancellation_text:
        'Se você cancelar a assinatura, poderá utilizar todas as funções do Pro até %{subscriptionExpiryDate}. Após essa data, sua conta WeTransfer Pro será convertida em uma conta gratuita e as suas transferências existentes vão expirar 28 dias depois disso.',
      cancellation_text_item_1: 'Enviar até %{transfer_limit}',
      cancellation_text_item_2: 'Proteja as transferências com uma senha',
      cancellation_text_item_3:
        'Gerencie e armazene %{storage_limit} transferências',
      cancellation_text_item_4:
        'Tenha seu próprio endereço de URL e sua própria página Pro personalizada',
      cancellation_text_item_heading:
        'A conta gratuita permite somente enviar %{free_size_limit} por transferência. Você não poderá mais:',
      cancellation_text_new:
        'Se cancelar sua assinatura agora, você poderá utilizar %{planName} até ao dia %{subscriptionExpiryDate}. Depois disso, será feito o downgrade para o plano gratuito.<br /><br />Atenção, todas transferências existentes expirarão o mais tardar 28 dias após o fim da sua assinatura.',
      cancellation_text_teams:
        'Se cancelar sua assinatura agora, você e sua equipe poderão usar o %{planName} até %{subscriptionExpiryDate}.<br /><br />Depois disso, você e os membros da sua equipe não poderão mais enviar transferências de arquivos, criar apresentações de slides e fazer quadros juntos. Sua conta passará para o plano gratuito e você poderá somente iniciar sessão na sua própria conta do WeTransfer.<br /><br />Atenção, todas as transferências existentes expirarão o mais tardar 28 dias após o fim da sua assinatura.',
      premium_trial: {
        feature_list_item_1: 'Transferências sem limite de tamanho',
      },
      premium_upgrade: {
        cta: 'Muda para o Premium',
        description:
          'Serão cobrados %{upfront_payment} e você poderá começar imediatamente no WeTransfer Premium. Sua nova assinatura de %{recurring_payment}/%{interval} será renovada em %{recurring_date}.',
        feature_list_item_1: 'Envie transferências sem limite de tamanho',
        feature_list_item_2: 'Armazenamento ilimitado',
        feature_list_item_3: 'Portais e avaliações ilimitados',
        feature_list_item_4: '%{storageLimit} de armazenamento',
        heading: 'Deseja fazer um upgrade do seu plano?',
      },
      unpaid_invoices: {
        heading: 'Você tem faturas não pagas',
        item: {
          issued_on: 'Emitido em',
          pay_invoice: 'Pagar fatura',
          pending_invoice: 'Pendente...',
        },
        subheading:
          'Parece que houve um problema com seus pagamentos anteriores. Pague todas as faturas pendentes ou sua assinatura Pro poderá ser cancelada.',
        subheading_2:
          'Se você tiver faturas pendentes, aguarde, pois tentaremos novamente dentro de alguns dias e você estará pronto para continuar assim que o pagamento for bem sucedido.',
      },
      upgrade_cta: 'Upgrade',
      app_subscription_banner: {
        title: 'Você fez sua assinatura a partir de %{app_name}',
        content:
          'Para você ver ou gerenciar sua assinatura, inicie sessão na sua conta da %{app_name} no celular ou no computador.',
        go_to: 'Acesse',
        learn_more: 'Saiba mais',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Cancelar assinatura',
      cancellation_disclaimer:
        '*Fique atento, pois suas transferências atuais vão expirar no máximo em 28 dias após a modificação do plano da sua conta.',
      'current-plan': 'Plano atual',
      'free-forever': 'Sempre gratuito',
      'free-usp-1': 'Envie até 2 GB',
      'free-usp-2': 'Sem armazenamento',
      'free-usp-3': 'As transferências expiram após 7 dias*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        'Se cancelar sua assinatura agora, poderá continuar usando o WeTransfer Pro até <b>%{expiration_date}</b>. Após essa data, sua conta será passada para uma conta do WeTransfer gratuita, o que, mesmo assim, ainda é uma solução excelente.',
      pagename: 'Não precisa mais das vantagens do Pro?',
      'pro-usp-1': 'Envie e recebe até %{transfer_limit}',
      'pro-usp-2': '1 TB de armazenamento',
      'pro-usp-3': 'Decida quando suas transferências vão expirar',
      'pro-usp-4':
        '<p>Sua própria <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">página Pro</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Desbloqueie Paste® Pro e Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Você cancelou sua assinatura Pro e a sua conta será modificada para uma conta gratuita do WeTransfer após <b>%{ends_at}.</b></p>\n<p>Informe-nos o motivo pelo qual você vai embora para podermos melhorar o WeTransfer Pro para você.</p>',
      reason_header: 'Que pena que você vai embora',
      cancel: 'Voltar',
      info: 'Diga-nos por que você vai embora e vamos continuar melhorando nossos serviços do WeTransfer Pro, levando em conta seus comentários.',
      pagename: 'Antes de você ir embora',
      yes_disable: 'Sim, continuar',
    },
    payment_failed: {
      selected_product: 'Um %{duration} do %{planTier}',
      change: 'Atualizar',
      complete_order: 'Concluir seu pedido',
      description: 'Revise suas informações e conclua o pedido',
      description_error:
        'Ocorreu um problema — revise suas informações e prossiga até a finalização da compra',
      description_refused:
        'Não foi possível processar o seu pagamento — verifique suas informações de pagamento e tente novamente',
      discount: 'Desconto',
      product_description: 'Um %{duration} com o WeTransfer Pro',
      title: 'Falta pouco!',
      total: 'Total',
      vat: 'IVA',
      your_details: 'Suas informações',
      your_order: 'Seu pedido',
      title_error: 'Hum, parece que houve um problema',
      title_refused: 'Hum, parece que houve um problema',
      payment_status_message:
        'Seu pagamento foi bem-sucedido, mas houve um problema e não pudemos atualizar seu plano automaticamente. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Entre em contato com o suporte</a>',
    },
    payment_methods: {
      billed_now: 'Faturado agora',
      info_content: {
        cancel_bullet:
          'Não se preocupe, você encontrará a opção de cancelamento em Configurações da conta > Pagamento.',
        initial_payment_bullet:
          'Após o pagamento inicial, serão cobrados %{price} %{interval} (a menos que decida cancelar sua assinatura, mas você nunca faria isso, certo? Certo?!)',
        update_payment_bullet:
          'Você poderá atualizar seus dados de pagamento e/ou dados de faturamento a qualquer momento antes do vencimento do próximo pagamento.',
        month:
          '- Após o primeiro pagamento, vamos cobrar %{price} de você todos os meses (a menos que decida cancelar sua assinatura do Pro. Mas você não faria isso, não é? Não é?!)\n- Não se preocupe. A opção de cancelar fica em Configurações da conta > Pagamento.\n- Você pode atualizar a forma de pagamento e/ou os dados da empresa antes da data do próximo pagamento.',
        year: '- Após o primeiro pagamento, vamos cobrar %{price} de você anualmente (a menos que decida cancelar sua assinatura do Pro. Mas você não faria isso, não é?).\n- Não se preocupe, a opção para cancelar fica em Configurações da conta > Pagamento.\n- Você pode atualizar sua forma de pagamento e/ou os dados da empresa antes da próxima data de pagamento.',
      },
      payment_cta: 'Concluir pagamento',
      payment_term: {
        monthly: 'uma vez por mês',
        yearly: 'uma vez por ano',
      },
      payment_title: 'Pagamento',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Mensal',
        year: 'Anual',
      },
      subtotal: 'Subtotal',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Seu método de pagamento',
      bancontact: 'Bancontact',
      card: 'Cartão de crédito',
      card_cvc: 'CVC',
      card_expiration: 'MM / AA',
      card_name: 'Nome do titular do cartão',
      card_number: 'Número do cartão',
      complete_payment: 'Conclua seu pagamento',
      creditcard: 'Cartão de crédito',
      discount: 'Desconto',
      do_not_refresh: 'Não atualize nem feche esta página',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL é um método de pagamento online dos Países Baixos, onde os clientes podem utilizar seus próprios bancos para efetuar o pagamento.',
      info: 'Atualizar o método de pagamento',
      payment_in_progress: 'Seu pagamento está sendo processado...',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: '/mês',
        year: '/ano',
      },
      select_bank: 'Selecione o seu banco',
      select_country: 'Selecione seu país',
      sofort: 'SOFORT',
      tax: 'IVA',
      title: 'Selecione a forma de pagamento',
      total: 'Total',
    },
    projects: {
      actions: {
        go_back: 'Todos os projetos',
        discard: 'Discard changes',
        edit: 'Edit',
        remove_transfer:
          'Delete this transfer? Files will be removed from this project and sent transfers.',
        save: 'Save',
        share: 'Compartilhar',
      },
      transfer_actions: {
        download: 'Download',
      },
      added_at: 'at %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Copiar link',
        link_copied: 'Link copied to clipboard',
        content_label: 'Copy link to this project',
        list_item_1: 'Download and view access only',
        list_item_2: 'Link stays the same, forever',
        title: 'Share project',
      },
      content: {
        empty_state:
          'Your project is currently empty. Get started by adding some files to start your project timeline.',
      },
      logo_title: 'Go back to wetransfer.com',
      logo_tooltip_caption: 'Back to WeTransfer',
      timestamp: '%{timeAgo} atrás',
      chat: {
        owner_button_label: 'Psst… Talk to us',
        owner_offline_greeting:
          'We’re currently offline, but let us know what you’re having trouble with and we’ll get back to you within one business day.',
        owner_online_greeting:
          'Let us know what you’re having trouble with and we’ll get back to you as soon as we can',
        receiver_button_label: 'Questions? We’re here to help',
        receiver_offline_greeting:
          'Let us know what you’re having trouble with and we’ll get back to you as soon as we can.',
        receiver_online_greeting:
          'Let us know what you’re having trouble with and we’ll get back to you as soon as we can.',
      },
      created_by: 'Created by %{user}',
      created_by_fallback: 'Created',
      deliverable_clipboard_modal: {
        content_label: 'Copy link to this deliverable',
        info: 'People will also be able to see your project',
        title: 'Share deliverable',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'This is not the Project you’re looking for…',
        limit:
          "Your potential is infinite, but you've reached your character limit",
        required: 'You know the drill. You can’t skip filling this out',
      },
      event: {
        project_created_byline:
          'Add some files to show what you’re working on.',
        project_created_title: 'Start of project',
      },
      file_count: {
        one: '%{count} arquivo',
        other: '%{count} arquivos',
      },
      just_now: 'just now',
      labels: {
        description: 'Description',
        name: 'Nome',
        new_name: 'Name your project',
      },
      logo: {
        cta: 'Add a logo',
        errors: {
          dimensions:
            'Your logo is smaller than 220 x 220 px. Try a bigger image',
          general: 'Hmm, something went wrong. Please give it another go',
          size: 'Your logo is bigger than 5 MB. Try a smaller file',
          type: 'Your logo is not a JPEG, GIF, or PNG. Try a different image',
        },
        instructions:
          'Your logo can be up to 5 MB. JPEGs and GIFs are okay, but PNGs with a transparent background work best',
        'instructions-title': 'Exiba sua marca',
      },
      name_modal: {
        content_label: 'Name or rename your Project',
        input_placeholder_0: 'Definitely a Cannes Lion',
        input_placeholder_1: 'A cure for the common cold',
        input_placeholder_2: 'The perfect crime',
        input_placeholder_3: 'I Write Songs Not Titles',
        input_placeholder_4: 'Award-Winning Idea',
        input_placeholder_5: 'Brand New Brand Campaign',
        input_placeholder_6: 'World domination',
        save: 'Save',
        text: 'Describe what you’re working on.',
        title: 'Name your project',
      },
      new_project_label: 'Start new project',
      noticebar: {
        'button-cancel': 'Cancelar',
        'button-clear-all-files': 'Apagar tudo',
        'button-close': 'Fechar',
        'button-delete': 'Excluir',
        'button-no': 'Não',
        'button-share': 'Compartilhar',
        'button-yes': 'Sim',
        'confirm-cancel': 'Cancelar esta transferência?',
        'confirm-clear-files-deliverable':
          'Apagar todos os arquivos de <strong><u> %{deliverableName}</u></strong> ?',
        'confirm-complete':
          'Envio realizado! Avise a todos que você adicionou mais arquivos.',
        'confirm-delete-deliverable':
          'Excluir <strong><u> %{deliverableName}</u></strong> e todos os arquivos que tenha enviado?',
        'confirm-first-complete':
          'Envio realizado! Compartilhe este projeto para que seus arquivos possam ser baixados.',
        deliverable_not_found_error: 'Opa, parece que o resultado foi excluído',
        general_error: 'Ih, ocorreu um erro. Tente novamente.',
      },
      'onboarding-promise': {
        description:
          'Descreva todo o trabalho que vai realizar para um projeto e simplifique a forma como compartilha. Crie uma lista de resultados, adicione arquivos durante o andamento do projeto. Chega de links diferentes para download.',
        title: 'Comece bem para continuar bem',
      },
      onboarding: {
        banner:
          'Atenção! Você está entre os poucos escolhidos com acesso ao Projects enquanto ele ainda está sendo construído (e aperfeiçoado). Podemos entrar em contato para saber sua opinião.',
      },
      pagename: 'Projetos',
      placeholders: {
        description: 'Faça uma breve descrição para o seu projeto',
        loading: 'Carregando...',
      },
      project: {
        notification: {
          name_saved: 'Nome salvo! Seu projeto tem cara de vencedor.',
        },
      },
      share_button_label: 'Compartilhar',
      unnamed_project_title: 'Projeto sem nome',
      watch_video: 'Assista ao vídeo',
    },
    transfer: {
      display_name_fallback: 'Transferência sem título',
      does_not_expire: 'sem <u>data de expiração</u>',
      expires_in: 'Expira em <span>%{time}</span>',
      downloaded_at: 'Download feito em %{date}, às %{time}',
      not_downloaded: 'Ainda não foi feito o download',
      email_bounced:
        'Hmm, o endereço de e-mail a quem você enviou o arquivo não funcionou',
      count_files: {
        one: '%{count} arquivo',
        other: '%{count} arquivos',
      },
      sent_datetime: 'Enviado em %{date} às %{time}',
      never_expires: 'Sem data de expiração',
      and_more: 'E mais %{count}',
      read_more: 'mais',
      copy_link: 'copiar link',
      message: 'Mensagem',
      total_downloads: 'Total de downloads',
      sent_to_recipients: {
        one: 'Enviado a %{count} pessoa',
        other: 'Enviado a %{count} pessoas',
      },
      no_transfers:
        'Todas as transferências que você enviar serão exibidas aqui',
      add_first_description:
        'Verifique o estado das suas transferências ou edite, reencaminhe ou elimine as mesmas',
      mobile: {
        download: 'Fazer download de todos os arquivos',
        remove: 'Excluir transferência',
      },
      delete_datetime: 'arquivos excluídos em %{date} às %{time}',
      detail: {
        plus_download_stats:
          'Adquira o Pro para ver quantas vezes suas transferências foram baixadas.',
        plus_password_expiration:
          'Adquira o Pro para configurar senhas e datas de expiração para as transferências.',
        plus_transfer_actions:
          'Adquira o Pro para gerenciar suas transferências e excluí-las quando quiser.',
        title: 'Os detalhes das suas transferências',
      },
      download_status_email: '%{count} de %{total} pessoas',
      download_status_email_text: {
        zero: 'Ainda não foi feito o download',
        one: '%{count} de %{total} pessoas',
        other: '%{count}/%{total} pessoas',
      },
      download_status_link: {
        one: 'uma vez',
        other: '%{count} vezes',
      },
      download_status_link_text: {
        zero: 'Ainda não foi feito o download',
        one: '1 vez',
        other: '%{count} vezes',
      },
      sent_moment: 'Enviado em %{moment}',
      total_downloads_tooltip:
        'Está diferente do que você esperava? Fizemos recentemente uma pequena mudança. Este número mostra somente os downloads concluídos.',
      display_name: {
        label: 'Título',
        label_mobile:
          'Adiciona um título para que as pessoas conheçam o conteúdo da sua transferência',
      },
      download_status_received_text: {
        zero: 'Nenhum arquivo baixado',
        one: 'Baixado',
        other: 'Baixados',
      },
      edit_display_name: {
        cancel: 'Cancelar',
        save: 'Salvar',
        title: 'Título',
      },
      received_datetime: 'Recebido em %{date} às %{time}',
      received_from: 'Recebido de',
      received_moment: 'Recebido em %{moment}',
      teams: {
        received_by: 'Recebido por',
        self: 'por mim',
        sent_by: 'Enviado por',
      },
      title: 'Título',
      set_password: {
        added: 'Adicionada',
        change: 'Alterar',
        remove: 'Remover',
        description:
          'Defina uma senha para controlar quem tem acesso a esta transferência.',
        remove_warning: 'Remover proteção por senha desta transferência?',
        yes_remove: 'Sim, remover',
      },
      set_expiration: {
        description:
          'Defina uma data de expiração para limitar o acesso a esta transferência.',
        label: 'Expira em',
      },
      anon_upsell_no_account:
        'Para editar ou rastrear os downloads para esta transferência antes de expirar, <a href="%{href}">cadastre-se</a> gratuitamente.',
      anon_upsell_found_account:
        'Para editar ou rastrear downloads desta transferência antes de ela expirar, <a href="%{href}">faça login</a>.',
      anon_upsell_no_account_with_button:
        'Crie uma conta para editar esta transferência antes que ela expire.',
      create_free_account: 'Criar conta gratuita',
    },
    transfers: {
      space_used_unlimited: ' %{space} de armazenamento utilizado',
      pagename: 'Transferências',
      search: 'pesquisar por nome de arquivo',
      search_results: {
        one: '%{count} resultado encontrado',
        other: '%{count} resultados encontrados',
        none: 'Sem resultados',
        retry:
          'Não conseguimos encontrar uma transferência correspondente à sua procura, tente novamente.',
      },
      space_used: '%{space} de %{totalSpace} utilizados',
      selected_text: {
        one: '%{count} transferência selecionada (%{size})',
        other: '%{count} transferências selecionadas (%{size})',
      },
      last_7_days: 'Enviado nos últimos 7 dias',
      over_7_days: 'Enviado há mais de 7 dias',
      sort_on: 'Ordenar por:',
      size: 'Tamanho',
      name: 'Nome',
      date: 'Data',
      delete: 'Excluir',
      download: 'Download',
      forward: 'Encaminhar',
      remove: 'Excluir',
      select: 'Selecionar',
      copy_link: 'Copiar link',
      sent_time_ago: 'Enviado há %{timeAgo}',
      files: {
        one: '%{count} arquivo',
        other: '%{count} arquivos',
      },
      confirm_transfer_delete: 'Espere – Deseja mesmo excluir a transferência?',
      confirm_forward:
        'Se encaminhar, você vai substituir a transferência que está em andamento. Prosseguir?',
      confirm_expired_transfer_delete:
        'Isto vai excluir definitivamente os arquivos e as informações da transferência. Prosseguir?',
      deleting_now: 'Vamos excluir para você agora',
      deselect_all_transfers: {
        one: 'Desmarcar todas as transferências',
        other: 'Desmarcar todas as %{count} transferências',
      },
      downloads: 'Downloads',
      expiration: 'Data de expiração',
      expiration_next: 'Expira nos próximos %{days}',
      expiration_no_date: 'Nenhuma data de expiração',
      expiration_not_soon: 'Não expira em breve',
      include_archived_switch_label:
        'Incluir informações das transferências excluídas',
      include_archived_switch_tooltip:
        'Estes elementos não contam para o seu limite de armazenamento',
      notify_completed:
        'Transferência concluída. Agora, você pode fechar esta janela. Ou fique olhando para ela, tudo bem.',
      preview: 'Ver prévia',
      remove_permanently: 'Excluir informações definitivamente',
      search_placeholder: 'Pesquisar por nome de arquivo ou por e-mail',
      select_all_transfers: {
        one: 'Selecionar todas as transferências',
        other: 'Selecionar todas as %{count} transferências',
      },
      space_left: '%{space} de %{totalSpace} restantes',
      teams_tip: {
        subtitle:
          'Esta página mostra sua atividade de transferências. Caso esteja se perguntando, os membros da sua equipe conseguem ver somente as próprias transferências.',
        title: 'Sua equipe Pro está crescendo…',
      },
      title: 'Transferências enviadas',
      view_details: 'Visualizar detalhes',
      edit_display_name: 'Modificar título',
      received_time_ago: 'Recebido há %{timeAgo}',
      search_title_placeholder:
        'Procurar por título, nome do arquivo ou e-mail',
      see_all: 'Ver todos (%{count})',
      sender: 'Remetente',
      sort_by_title: 'Título',
    },
    accountinfo: {
      pagename: 'Informações da conta',
      signed_in_as: 'Sessão iniciada como %{name}',
      sign_out: 'Terminar sessão',
      paid_on: 'Pago em',
      no_invoices:
        'Seus recibos serão exibidos aqui, mas aparentemente você ainda não tem nenhum recibo. Que sorte!',
      subscription_info:
        'Sua assinatura do Pro de %{deal} será renovada automaticamente em %{autorenewal_attempt}.',
      payment_success: {
        monthly:
          'Ótimo, agora você pode usufruir do WeTransfer Pro por um mês inteiro',
        monthly_renewal:
          'Ótimo, agora você pode usufruir do Pro por mais um mês',
        yearly:
          'Ótimo, agora você pode usufruir do WeTransfer Pro por um ano inteiro',
        yearly_renewal:
          'Ótimo, agora você pode usufruir do Pro por mais um ano',
      },
    },
    changepassword: {
      pagename: 'Alterar senha',
    },
    invoices: {
      pagename: 'Recibos',
    },
    reviewbilling: {
      pagename: 'Confirme suas informações de pagamento',
      information:
        'Para alterar sua forma de pagamento, você terá que renovar sua assinatura ao mesmo tempo',
      information_payment:
        'Serão cobrados %{deal} pelo próximo %{period} do Pro – sua assinatura será válida até %{expiry}',
    },
    renewbilling: {
      pagename: 'Revise suas informações e renove',
    },
    link_downloads_unsubscribe: {
      body: 'Você pode cancelar sua inscrição das notificações sobre os downloads das suas transferências e mesmo assim poderá acompanhar seus downloads no painel de arquivos enviados.',
      cta: 'Ir para as minhas transferências enviadas',
    },
    transfer_in: {
      title: 'Enviar arquivos para',
      recipient_input_title: 'Enviar para',
      add_files: 'Adicionar ficheiros',
      folder_upload: 'Ou selecione uma pasta',
      tooltip: {
        title: 'Atenção',
        text: 'Seus arquivos serão enviados com segurança para a conta do WeTransfer de %{name}.',
      },
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Escolher da galeria',
        },
        next_button: 'Tudo pronto',
        description:
          'Escolha as imagens de fundo para a sua página do WeTransfer novinha em folha. Você pode adicionar até cinco vídeos ou imagens giratórios para colocar você ou sua marca em evidência.',
      },
      upload_wallpaper: {
        add_text: 'Enviar uma imagem',
        add_description:
          'Para alcançar os melhores resultados possíveis, sugerimos que envie uma imagem de 2560 x 1600 pixels. O tamanho máximo dos arquivos é de 3 MB.',
        upload_text: 'Enviar uma imagem ou vídeo',
      },
      preview: {
        wallpaper_credits_prefix: 'Imagem de fundo de',
      },
      1: {
        description:
          '&quot;Personalize o que as pessoas veem sempre que você enviar arquivos. E com sua própria página do WeTransfer, qualquer pessoa pode enviar %{transfer_limit} de transferências para você —basta informar seu URL. Seu endereço de e-mail será apresentado na página para que as pessoas possam confiar que os respetivos arquivos serão enviados para você.<br /><br />\nPrimeiro, escolha o seu URL.&quot;',
        next: 'Próximo',
        skip: 'Ignorar',
        warning:
          '<strong> Cuidado,</strong> você pode definir isso somente uma vez (mas não queremos pressionar!)',
        'blurb-1':
          'Crie sua página do WeTransfer para ter um visual profissional quando alguém fizer download dos seus arquivos e torne (ainda) mais fácil o envio de transferências para você.',
        'blurb-2': 'Primeiro, escolha seu URL.',
        welcome: 'Marque presença com sua própria página no WeTransfer',
        information:
          'Não se preocupe, você poderá alterar mais tarde em <strong>Branding</strong>.',
        description_unlimited:
          'Personalize o que as pessoas veem sempre que enviar arquivos. E com sua própria página no WeTransfer, todos poderão enviar transferências de qualquer tamanho, basta você informar o URL. Seu endereço de e-mail será mostrado na página para que as pessoas possam confiar que os seus arquivos serão enviados para você.<br /><br /> \nPrimeiro, escolha seu URL.',
      },
      2: {
        description:
          'Você pode selecionar até cinco fundos de tela (ou papéis de parede, como gostamos de chamar) para o seu perfil.\n\nDê destaque a você ou à sua empresa e envie seus arquivos com estilo',
        pick: 'Escolha da galeria',
        title: 'Impressione em cada transferência',
        upload: 'Envie os seus próprios',
      },
      3: {
        description:
          'O link <strong>%{customLink}</strong> já está configurado. Agora você pode adicionar este link ao seu site para as pessoas enviarem transferências de até %{transfer_limit} para você ou para enviarem, bem, coisas.',
        done: 'Concluído',
        title: 'Está ótimo!',
        description_unlimited:
          '<strong>%{customLink}</strong> foi configurado. Agora você pode adicionar este link ao seu site para que as pessoas possam enviar arquivos de qualquer tamanho para você, ou você pode, se quiser, enviar coisas.',
      },
    },
    contact: {
      add_contact: 'Adicionar contato',
      add_first_description:
        'Também guardamos aqui os endereços de e-mail das pessoas para quem você enviar arquivos',
      add_to_transfer: 'Adicionar para transferir',
      remove_from_transfer: 'Retirar da transferência',
      confirm_delete: {
        one: 'Deseja mesmo excluir esse contato?',
        other: 'Deseja mesmo excluir %{count} contatos?',
      },
      contact_count: {
        one: '%{count} contato',
        other: '%{count} contatos',
      },
      edit: 'Editar',
      mobile: {
        add: 'Adicionar contato',
      },
      no_contacts: 'Adicione seu primeiro contato!',
      pagename: 'Contatos',
      remove: 'Excluir',
      search_count: {
        one: '%{count} resultado encontrado',
        other: '%{count} resultados encontrados',
      },
      search_placeholder: 'procurar e-mail, nome ou empresa',
      select: 'Selecionar',
      selected_text: {
        one: '%{count} contato selecionado',
        other: '%{count} contatos selecionados',
      },
      teams_tip: {
        subtitle:
          'Quando você enviar uma transferência para alguém, adicionaremos a pessoa à sua lista de contatos. Todas as pessoas da sua equipe podem criar uma lista.',
        title: 'Sua equipe Pro está crescendo…',
      },
    },
    unsubscribeexpiration: {
      button: 'Cancelar a assinatura',
      button_unsubscribed: 'Voltar ao WeTransfer',
      description:
        'Não quer mais receber nossos e-mails? Não há problema, podemos parar de lembrar você sobre as transferências que estão prestes a expirar.',
      description_unsubscribed:
        'Você vai deixar de receber e-mails com notificações sobre as transferências que estão prestes a expirar',
      no_email: 'você',
      title: 'Cancelar a assinatura de e-mails com lembretes',
      title_unsubscribed: 'Tudo pronto!',
      downloaded: {
        body: 'Ok. Você pode cancelar sua inscrição de todos os e-mails sobre as transferências prestes a expirar depois que os arquivos tiverem sido baixados. Isto não terá qualquer influência sobre os e-mails enviados caso ninguém tenha baixado seus arquivos.',
        cta: 'Cancelar inscrição',
        title:
          '"Meus arquivos foram baixados, não preciso receber e-mails sobre transferências prestes expirar"',
      },
      not_downloaded: {
        body: 'Não há problema. Você pode cancelar sua inscrição de todos os e-mails sobre transferências prestes a expirar, mesmo se ninguém tiver baixado os seus arquivos.',
        cta: 'Cancelar inscrição',
        title:
          'Não quer receber e-mails sobre transferências prestes a expirar?',
      },
      pro: {
        body_1:
          'Tudo bem, você pode cancelar sua inscrição destes e-mails de notificação. Nos detalhes da sua transferência, você ainda poderá acompanhar quando as transferências vão expirar e modificar as datas de expiração sempre que quiser.',
        body_2:
          'Psst, você pode entrar em contato conosco pelo email <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> se mudar de ideia ou se tiver algum problema. Sem problemas!',
        cta: 'Cancelar inscrição',
        title:
          'Não quer receber e-mails sobre transferências prestes a expirar?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Deseja mesmo limpar os seus cookies?',
        },
      },
    },
    about_plus: {
      checklist: {
        title:
          'Faça upgrade para o Pro ainda hoje, por %{currency}%{price} por mês',
      },
    },
    advertise: {
      gallery: {
        preview: 'Ver prévia',
      },
      guidelines: {
        advert_static: {
          title: 'Fundo de tela estático',
        },
      },
    },
    billinginfo: {
      pagename: 'Dados para faturamento',
    },
    help: {
      button_all_answers: 'Mais respostas',
      page_title: 'Ajuda rápida',
      read_more: 'Ler mais',
      search_button: 'Pesquisar',
      search_placeholder: 'Em que podemos ajudar?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Carregando...',
    },
    payment_update: {
      bancontact: {
        info: 'Aviso: para verificar se os seus dados estão corretos, o Bancontact vai cobrar uma taxa única de € 0,50',
      },
      confirm_update: 'Confirmar',
      ideal: {
        info: 'Aviso: para verificar se os seus dados estão corretos, o iDEAL vai cobrar uma taxa única de € 0,01',
      },
      info: 'Aviso: para verificar se os seus dados estão corretos, o iDEAL vai cobrar uma taxa única de € 0,01',
      sofort: {
        info: 'Aviso: para verificar se os seus dados estão corretos, o SOFORT vai cobrar uma taxa única de € 1',
      },
      title: 'Atualizar informações de pagamento',
      update_in_progress: 'Atualizando seus dados...',
    },
    sign_in: {
      account: 'Não tem conta?',
      upgrade: 'Faça o upgrade para o WeTransfer Pro',
    },
    signin: {
      account_cta: 'Crie uma conta',
      account_item_1: 'Envie até %{size_limit}',
      account_item_2: 'Gerenciar transferências',
      account_item_3: 'Armazene até %{storage_limit}',
      account_subtitle: 'Grátis',
      plus_cta: 'Adquira o WeTransfer Pro',
      plus_item_1: 'Envie até %{size_limit}',
      plus_item_2: 'Gerenciar transferências',
      plus_item_3: 'Armazene até %{storage_limit}',
      plus_item_4: 'Seus próprios fundos de tela',
      plus_item_5: 'Um URL personalizado',
      plus_item_6: 'Proteja as transferências com uma senha',
      plus_month: '/mês',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Cancelar convite',
      },
      invitees: {
        title: 'Convite enviado. Aguardando resposta',
      },
      member: {
        action_demote: 'Remover como administrador',
        action_promote: 'Colocar como administrador',
        action_revoke: 'Eliminar equipe',
      },
      members: {
        title: 'Na sua equipe',
      },
      no_access: {
        description:
          'Fique atento, avisaremos você quando estiver tudo pronto. ',
        title: 'Opa, parece que este recurso ainda é um segredo. ',
      },
      subtitle: {
        members: {
          one: '%{count} membro',
          other: '%{count} membros',
        },
        pending: '%{pendingCount} convidado(s)',
      },
      tip: {
        button: 'Saiba mais',
        subtitle:
          'Com nosso novíssimo recurso Pro para equipes, deixamos a melhor experiência do WeTransfer ainda melhor! Adicione novos membros gratuitamente. Utilize o formulário simplificado abaixo para manter a sua equipe em movimento. Quando aceitarem seu convite, estará tudo pronto para começar!',
        title: 'Na equipe, o importante é a equipe e não o indivíduo...',
      },
      title: 'Equipe',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Expira em %{expiry}',
      },
      recipients: 'Enviando para',
      upsell: {
        benefit_one: 'Veja quando os arquivos foram baixados',
        benefit_three: 'Avalie e reenvie transferências antigas',
        benefit_two: 'Veja quem baixou seus arquivos',
        button: {
          action: 'Quero saber mais',
          cancel: 'Não, obrigado',
        },
        heading:
          'Gerencie suas transferências com facilidade com o WeTransfer Pro',
        title: 'Informações sobre a sua transferência',
      },
    },
    transferReceived: {
      'empty-description':
        'As transferências enviadas para você ficam aqui. Não se preocupe, elas não vão ocupar espaço',
      'empty-title': 'Monitore as transferências',
      empty: {
        description:
          'Aqui você verá todas as transferências enviadas para o seu e-mail ou enviadas por upload para você. Não se preocupe, elas não usarão seu armazenamento.',
      },
      banner: {
        freeUser: {
          text: 'Faça o upgrade para receber com facilidade. Tenha um URL personalizado <strong>seunome.wetransfer.com</strong> e uma página com identidade visual para envios.',
          link: 'Fica a saber mais',
          cta: 'Upgrade',
        },
        paidUser: {
          withUrl: {
            cta: 'Copiar URL',
            premium: {
              text: 'Você pode receber transferências ilimitadas em <strong>%{personalisedUrl}</strong>',
            },
            pro: {
              text: 'Qualquer pessoa pode enviar para você até %{transferLimit} transferências em <strong>%{personalisedUrl}</strong>',
            },
          },
          withoutUrl: {
            text: 'Defina seu URL <strong>seunome.wetransfer.com</strong> para que qualquer pessoa possa enviar arquivos para você.',
            link: 'Fica a saber mais',
            cta: 'Ir para a identidade visual',
          },
        },
      },
    },
    unsubscribeonboarding: {
      action: 'Cancelar assinatura',
      back: 'Voltar ao WeTransfer',
      contact:
        'Ei, se encontrar algum problema que não consiga solucionar, envie um e-mail para <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a>, sem ressentimentos.',
      done: 'Tudo pronto!',
      message:
        'Você pode cancelar sua assinatura dos nossos e-mails introdutórios. Não se preocupe, você vai continuar recebendo os e-mails importantes.',
      title: 'Sua caixa de entrada está muito cheia?',
    },
    userinfo: {
      pagename: 'Informações pessoais',
    },
    free_onboarding: {
      close: 'Fechar',
      finish_tour: 'Pronto',
      next: 'Próximo',
      send_files: 'Basta ir em enviar arquivos agora',
      start_tour: 'Veja o que temos mais para oferecer',
      step_one: {
        body_1:
          'Agora que você verificou o endereço de e-mail da sua conta, não é necessário repetir o processo sempre que fizer uma transferência. Chega de códigos de verificação!',
        body_2:
          'Acompanhe todas as transferências que enviar e receber em um só local. Veja quantas vezes seus arquivos são baixados. Reenvie, encaminhe, ou exclua suas transferências com um clique.',
        header_1: 'Verificação única',
        header_2: 'Gerencie suas transferências',
        subtitle:
          'Chega de perder códigos de verificação e links de download. Sua nova conta disponibiliza a forma mais simples de enviar arquivos grandes. De graça.',
        title_1: 'Envia arquivos <strong>como preferir</strong>',
        title_2: 'com o WeTransfer',
      },
      step_three: {
        body_1:
          'Não importa se trata-se de um vídeo no seu telefone ou um link no seu computador, salve toda sua inspiração em um só local. Para começar, abra o Collect com o inicializador (aquele ícone no canto superior esquerdo) ou use o link abaixo.',
        cta: 'Acessar o Collect',
        title_1: '<strong>Salve sua inspiração</strong> quando ela surgir',
        title_2: 'com o Collect',
      },
      step_two: {
        body_1:
          'Apresente ideias. Exiba seu trabalho em andamento. Mantenha a sincronia. Sem nunca mais ter que formatar outro slide. Para começar, abre o Paste com o inicializador (aquele ícone no canto superior esquerdo) ou use o link abaixo.',
        cta: 'Acessar o Paste',
        title_1: 'Crie <strong>slides em segundos</strong>',
        title_2: 'com o Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Experimente os portais',
        pill: 'Recurso novinho em folha',
        text: 'Conheça os <strong>portais</strong>, a forma mais simples de encerrar seus projetos. Convide clientes e colaboradores para verem arquivos e selecionarem favoritos, sem ter que baixar nada.',
        title: 'Compartilhe trabalhos. Receba opiniões. Tudo em um só local.',
      },
    },
    not_found: {
      body: 'Retorne para <a href="https://wetransfer.com/">wetransfer.com</a> ou divirta-se com algumas <a href="https://wepresent.wetransfer.com/">coisas bonitas que escrevemos</a> .',
      image_alt: 'Ocorreu um erro',
      title: 'Não foi possível encontrar esta página.',
    },
    password_and_security: {
      title: 'Senha e segurança',
      'two-factor-authentication': {
        description: {
          enabled: 'Desde %{date}',
        },
        disable: 'Desligar',
        done: 'Pronto',
        enable: 'Ligar',
        get_recovery_codes: 'Receba códigos de recuperação',
        next_step: 'Próximo',
        recovery_code_action: 'Gerar novos códigos',
        recovery_code_keep_safe:
          'Cada código só pode ser utilizado uma vez, mas se quiser você pode receber mais códigos.',
        recovery_code_need_more:
          'Precisa de mais códigos de recuperação? Você pode gerar mais códigos quando quiser, mas lembre-se de que isto vai invalidar os códigos gerados antes.',
        recovery_code_title: 'Seus códigos de recuperação',
        require_password_action: 'Entrar',
        require_password_text: 'Digite sua senha para prosseguir',
        step_one_action: {
          app_store: 'Baixar na App Store',
          google_play: 'Pegar no Google Play',
        },
        step_one_label: 'Passo 1 (de 3)',
        step_one_text:
          'Você vai precisar de um app de autenticação no teu telefone. Se já tiver o Google Authenticator (ou outro app semelhante), clique em "próximo".',
        step_one_title: 'Baixe o Google Authenticator',
        step_three_label: 'Passo 3 (tudo pronto!)',
        step_three_text:
          'Se precisar acessar e seu celular não estiver com você (ouvimos dizer que isso acontece), use um destes códigos de recuperação. Não salvaremos estes códigos nem os mostraremos para você novamente, portanto, anote-os agora e guarde-os bem, como se fossem os códigos de acesso à sua conta bancária.',
        step_three_text_2:
          'Guarde estes códigos com a mesma segurança que você guarda a senha da sua conta bancária! Cada um desses códigos só pode ser utilizado uma vez.',
        step_three_title: 'Salve os códigos de recuperação',
        step_two_form: {
          error: 'Opa, este código está errado ou expirou',
          label: 'Código de verificação',
        },
        step_two_label: 'Passo 2 (chegamos na metade)',
        step_two_text:
          'Utilize seu app de autenticação para ler este código de barras. O app criará um código de verificação com seis dígitos. Insira este código abaixo.',
        step_two_text_mobile:
          'Digite esta chave no seu app de autenticação. O app vai gerar um código de verificação com seis dígitos. Insira este código abaixo.',
        step_two_title: 'Ler o código de barras',
        step_two_title_mobile: 'Digite a chave',
        text: {
          protect_account:
            'Use seu celular e proteja sua conta com mais uma camada de segurança.',
        },
        title: 'Autenticação em duas etapas',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Tenha o melhor do Paste® e do Collect',
      },
      cta: 'Não, quero continuar no Pro',
      'cta-2': 'Cancelar assinatura',
      disclaimer: {
        collect:
          'Seu espaço de armazenamento passará de 200 GB para 5 GB no Collect',
        paste:
          'De um número ilimitado de apresentações você passará a ter três no Paste®',
        'team-member':
          'Você será removido de %{currentTeam} no WeTransfer Pro.',
        teams:
          'Sua equipe de %{amountOfMembers} será removida de %{currentTeam}',
        title:
          'Quando sua assinatura atual expirar em <strong>%{date}</strong>:',
        'transfer-expiry':
          'Suas atuais transferências serão excluídas após 28 dias',
        'transfer-team-member':
          'Você não poderá enviar e receber transferências como parte da equipe e não poderá gerenciar as atuais transferências da equipes.',
      },
      'password-expiry': {
        title:
          'Proteja suas transferências com uma senha e decida quando elas expiram',
      },
      personalization: {
        title: 'Personalize sua página do WeTransfer',
      },
      portals: {
        text: 'Com o %{planName}, você pode utilizar os <a href="%{href}" target="_blank">portais</a> para compartilhar trabalho para os clientes avaliarem, sem ter que baixar nada.',
        title: 'Compartilhe seu trabalho e receba comentários em um só local',
      },
      'stay-pro': 'Manter assinatura',
      'storage-limit': {
        title: 'Tenha %{storage_limit_pro} de armazenamento por pessoa',
      },
      subtitle:
        'Se cancelar agora, a partir de %{date} você não vai mais poder:',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Convide membros da equipe</a> para enviar, receber e gerenciar transferências em conjunto, ou trabalhe sozinho gratuitamente.',
        'team-member-text':
          'Você será removido da sua equipe e não poderá mais acessar, receber ou gerenciar transferências.',
        'team-owner-text':
          '<a href="%{href}" target="_blank">%{amountOfMembers} membros da sua equipe</a> não poderão mais enviar, receber ou gerenciar transferências em conjunto.',
        title: 'Trabalhe em equipe nas grandes ideias',
      },
      title: 'Quer mesmo desistir do %{planName}?',
      'transfer-limit': {
        text: 'Atualmente, você pode enviar e receber transferências maiores, muito mais do que os %{transfer_limit_free} gratuitos.',
        title: 'Compartilhar uma tonelada de trabalhos criativos',
      },
      'transfer-unlimited': {
        text: 'Você podes enviar (e receber) transferências sem limite de tamanho de arquivo. Infinitamente mais do que o limite gratuito de %{transfer_limit_free}.',
        title: 'Envie transferências de qualquer tamanho',
      },
      'us-price-change': {
        title:
          'Se você cancelar sua assinatura e quiser reativá-la a qualquer momento, <br/> a assinatura será reativada com os <a href="https://wetransfer.com/pricing" target="_blank">preços atualizados</a>.',
      },
    },
    pricing: {
      pro: {
        per_person: 'por pessoa',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Criar conta',
        current_plan: 'Plano atual',
        sign_up: 'Inscreva-se',
        switch_premium: 'Passar para o Premium',
        switch_pro: 'Mudar para o Pro',
        upgrade: 'Upgrade',
      },
      faq: {
        answers: {
          answer_1:
            'Você pode começar a usar o WeTransfer Pro ou o WeTransfer Premium assim que tiver feito o pagamento. Além disso, vamos enviar um e-mail de confirmação com sua fatura paga em anexo. <br /><br />\n\nQuando entrar na sua conta você vai poder enviar transferências maiores, começar a usar os portais, e criar sua própria página no WeTransfer imediatamente. Se alguma transferência anterior tiver sido enviada enquanto você estava usando o plano gratuito, também será possível alterar as datas de validade para quando quiser.',
          answer_2:
            'Com o WeTransfer, qualquer pessoa pode baixar seus arquivos. Não há necessidade de acessar ou se inscrever. As pessoas terão que aceitar nossos Termos de Serviço e podemos pedir que aceitem cookies, mas é só isso! <br /><br />\n\nSe quiser compartilhar algum trabalho ou colaborar nos portais (o mais recente recurso do WeTransfer), não será necessário que seus clientes e colaboradores se inscrevam para ver e selecionar arquivos, adicionar comentários, aprovar ou baixar arquivos. Basta adicionar membros da equipe ao seu plano Pro ou Premium se quiser permitir que as pessoas adicionem comentários e criem portais com você.',
          answer_3:
            'Com um plano Pro ou Premium, você pode criar sua própria página no WeTransfer, onde qualquer pessoa pode enviar arquivos para você com o limite de transferência do seu plano. Isso significa que você podes receber dos clientes ou colaboradores os arquivos grandes que precisa, sem que eles tenham conta. Basta que tenham o URL da sua página. (Podemos pedir que verifiquem o endereço de e-mail deles para proteger você contra "príncipes estrangeiros" que "queiram enviar dinheiro para você").',
          answer_4:
            'Primeiro, inscreva-se no WeTransfer Pro ou WeTransfer Premium . Não é possível adicionar membros à equipe no plano gratuito. E qualquer que seja o plano que escolher, os membros da sua equipe terão todos os mesmos benefícios (para que você não tenha o Premium e alguns membros da equipe tenham o Pro, por exemplo). Os membros da equipe poderão enviar e receber transferências maiores na sua página do WeTransfer e gerenciar transferências em um resumo geral compartilhado. <br /><br />\n\nQuando assinar o plano mais adequado para a sua equipe, você vai poder convidar quantos membros da equipe quiser nas configurações de gerenciamento da sua equipe. Você podes adicionar e remover membros da sua equipe quando quiser altura enquanto sua assinatura estiver ativa.',
          answer_5:
            'Aceitamos PayPal e cartões de crédito das principais redes como Visa, Mastercard, e American Express. Aceitamos também outros sistemas de pagamento online em alguns países. <br /><br />\n\nNão aceitamos transferências bancárias diretas porque é necessário ter uma assinatura anual ou mensal recorrente. (Enviaremos um e-mail para você antes de isto acontecer pela primeira vez).',
          answer_6:
            'Se não tiver o armazenamento ilimitado com o WeTransfer Premium, será necessário liberar um pouco de espaço de armazenamento excluindo algumas das transferências que enviou ou com o upgrade do seu plano. Enquanto não fizer isso, não será possível enviar novas transferências. <br /><br />\n\nSe estiver utilizando o WeTransfer gratuito, todas as s transferências de até 2 GB são apagadas automaticamente após 7 dias. Portanto, não se preocupe, não é possível ultrapassar seu limite de armazenamento.',
          answer_6_variant_asterisk:
            'Você terá que liberar espaço de armazenamento excluindo algumas das transferências que enviou ou fazendo um upgrade do seu plano. Enquanto não faz isso, não será possível enviar novas transferências. <br /><br />\n\nSe você tiver uma assinatura Premium e atingires 5 TB, entre em contato com a nossa equipe de suporte e peça mais espaço de armazenamento. O limite máximo anual é de 15 TB. <br /><br />Se estiver utilizando o WeTransfer gratuito, todas as transferências que enviou com até 2 GB são excluídas automaticamente após 7 dias. Portanto, não se preocupe, não é possível ultrapassar o limite de armazenamento.',
          answer_6_variant_limited_storage:
            'Você terá que liberar espaço de armazenamento excluindo algumas das transferências que enviou ou fazendo um upgrade do seu plano (salvo se tiver o plano Premium). Enquanto não faz isso, não será possível enviar novas transferências. <br /><br />\n\nSe estiver utilizando o WeTransfer gratuito, todas as transferências que enviou com até 2 GB são excluídas automaticamente após 7 dias. Portanto, não se preocupe, não é possível ultrapassar o limite de armazenamento.',
          answer_7:
            'Sua assinatura será renovada automaticamente (enviaremos um e-mail para você antes de isto acontecer pela primeira vez), mas você pode cancelar quando quiser. <br /><br />\n\nPara passar a usar o WeTransfer gratuito, basta acessar as configurações da sua <strong>conta</strong> e cancelar sua assinatura. Você (e qualquer membro da equipe) poderá continuar usando seu plano Pro ou Premium até o fim do período da sua assinatura atual.',
          answer_8:
            'Milhões de pessoas em todo o mundo utilizam o WeTransfer e nosso conjunto de ferramentas para movimentar ideias. Todos os meses, mais de 2 bilhões de arquivos são compartilhados em nossa plataforma.<br /><br />\n\nPara manter suas ideias a salvo contra ataques ou exploração, seus arquivos são criptogtafados quando são transferidos (TLS) e quando são armazenados (AES-256). Quando armazenados, seus arquivos só podem ser acessados por meio dos links exclusivos enviados para o remetente e o destinatário.',
        },
        questions: {
          question_1: 'O que acontece após eu me inscrever e pagar?',
          question_2: 'Meus contatos precisam se inscrever?',
          question_3:
            'Posso receber transferências maiores de todos os contatos? ',
          question_4:
            'Como faço para adicionar (e remover) membros de uma equipe?',
          question_5: 'Quais formas de pagamento posso usar?',
          question_6:
            'O que acontece se eu ultrapassar meu limite de armazenamento?',
          question_7: 'Como faço para cancelar?',
          question_8:
            'Posso confiar no WeTransfer? Qual é o grau de segurança dele?',
        },
        title: 'Dúvidas frequentes',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Publicidades (e arte)',
            custom: 'Envie o seu',
            feature_1: 'Página personalizada do WeTransfer',
            feature_2: 'Fundos de tela',
            feature_3: 'E-mails personalizados no WeTransfer',
          },
          title: 'Exiba sua marca',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} de armazenamento',
            title: 'Collect do WeTransfer',
          },
          paste: {
            limited_decks:
              'Até %{pasteDecksLimit} apresentações com o logotipo padrão do Paste',
            title: 'Paste® do WeTransfer',
            unlimited_decks:
              'Apresentações ilimitadas com a sua identidade visual',
          },
          title: 'Complete suas ferramentas criativas',
        },
        expiry: 'As transferências expiram após %{days} dias',
        extra_storage: 'Mais %{storageLimit} por pessoa',
        monthly_price: '%{price} mensalmente por pessoa',
        portals: {
          features: {
            feature_1: 'Portais',
            feature_2: 'Avaliações',
            feature_3: 'Identidade visual do cliente',
          },
          title: 'Compartilhe trabalho para opinião e aprovação',
        },
        security: {
          features: {
            feature_1: 'Datas de validade personalizadas',
            feature_2: 'Transferências protegidas por senha',
            feature_3: 'Criptografia de dados',
            feature_4: 'Autenticação em duas etapas',
          },
          title: 'Proteja suas transferências',
        },
        storage_limit: '%{storageLimit} por pessoa',
        teams: {
          features: {
            feature_1: 'Convide membros para a equipe',
            feature_2: 'Resumo das transferências compartilhadas',
            feature_3: 'Armazenamento compartilhado',
            feature_4: 'Marca compartilhada',
          },
          title: 'Entregue trabalhos como uma equipe',
          subtext: {
            text: 'Somente se adquirir uma assinatura pelo nosso site.',
            learn_more: 'Saiba mais',
          },
        },
        tooltips: {
          tooltip_1:
            'Todas as transferências que você enviar são contabilizadas no armazenamento',
          tooltip_10:
            'Você podes enviar e armazenar arquivos de forma segura com a criptografia TLS e AES-256e',
          tooltip_11:
            'Monitore os downloads e gerencie as transferências em conjunto',
          tooltip_12:
            'Exiba seu trabalho (da equipe) com fundos de tela e e-mails com identidade visual',
          tooltip_13:
            'O Paste é uma ferramenta de apresentação para design de apresentações com cores, alinhamento e layout dinâmicos',
          tooltip_14:
            'O Collect permite salvar e organizar imagens, vídeos, música e links entre dispositivos',
          tooltip_2:
            'Os destinatários podem baixar seus arquivos sem ter que entrar ou se cadastrar',
          tooltip_3: 'Veja quem baixou (e quem não baixou) seus arquivos',
          tooltip_4: 'Organize seu trabalho por cliente e por projeto',
          tooltip_5:
            'Convide os clientes para que vejam e selecionem arquivos, adicionem comentários e aprovem, sem necessidade de baixar nada',
          tooltip_6:
            'Adicione um logotipo para personalizar seus portais para cada cliente',
          tooltip_7:
            'Sua página no WeTransfer é onde as pessoas baixam seus arquivos e podem enviar transferências para você com o limite de tamanho do seu plano',
          tooltip_8:
            'Os fundos de tela são os vídeos e imagens que você vê em segundo plano quando está enviando e recebendo arquivos no wetransfer.com',
          tooltip_9:
            'Uau, achávamos que ninguém lia isto. Você provou que estávamos errados. Que bom! As capturas de tela poderão ou não ser retuitadas pelo @WeTransfer no twitter',
        },
        transfer_classic: {
          features: {
            feature_1: 'Limite de tamanho de transferência',
            feature_2: 'Armazenamento',
            feature_3: 'Downloads sem conta',
            feature_4: 'Rastrear downloads',
            feature_5: 'App do iOS',
          },
          title: 'Enviar arquivos grandes',
        },
        unlimited: 'Sem limites',
        yearly_price: '%{price} anualmente por pessoa',
      },
      header: {
        subtitle:
          'Não importa se está enviando arquivos grandes por prazer ou entregando trabalhos a clientes. Transfira seus projetos criativos com o WeTransfer.',
        title: {
          english_1: 'Você tem as ideias,',
          english_2: 'nós temos os planos',
          general: 'Planos e preços',
        },
      },
      plans: {
        billing: {
          discount: 'Economize %{percentage} (isso mesmo)',
          discount_up_to: 'Economize até %{percentage} (isso mesmo)',
          discount_up_to_short: 'Economize até %{percentage}',
          monthly: 'Faturamento mensal',
          yearly: 'Faturamento anual',
        },
        free: {
          subtitle: 'Enviar arquivos ocasionalmente',
          title: 'Grátis',
          usp: {
            feature_1: 'Envie até %{transferLimit}',
            feature_2: 'Não é necessário verificar as transferências',
          },
        },
        premium: {
          subtitle: 'Compartilhar trabalho sem limites',
          title: 'Premium',
          usp: {
            feature_1: 'Sem limite de tamanho para as transferências',
            feature_2: 'Armazenamento ilimitado',
            feature_2_subtitle:
              '*O limite inicial é de %{storageLimit}, com a opção de adicionar mais armazenamento a pedido. Aplica-se um limite máximo anual de %{annualStorageLimit}. Consulte nossos <a href="/legal/terms" data-route-type="premium" target="_blank">Termos de Serviço</a> para mais informações.',
            feature_3: 'Portais e avaliações ilimitadas',
          },
        },
        pro: {
          subtitle: 'Enviar arquivos muito grandes regularmente',
          title: 'Pro',
          usp: {
            feature_1: 'Envie e receba até %{transferLimit}',
            feature_2: '%{storageLimit} de armazenamento por pessoa',
            feature_3: '%{portalsLimit} no portal, sem limite de avaliações',
          },
        },
        tagline: {
          free: 'não tem dinheiro? Sem problema',
          monthly: 'preço mensal por pessoa',
          yearly: 'preço anual por usuário',
          per_person_monthly: 'por pessoa, faturamento mensal',
          per_person_yearly: 'por pessoa, faturamento anual',
          tax_included: 'imposto incluído',
        },
        title: 'Escolha seu plano',
        banner_text:
          'Economize %{discount_amount}/mês <span>pagando anualmente</span>',
        month: 'mês',
      },
      skip_link: 'Tenha para mais recursos',
    },
    pro_classic: {
      hero: {
        cta_1: 'Saiba mais',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Você tem as ideias, nós temos os planos',
      },
      cta: 'Só quero enviar arquivos',
      free_panel: {
        cta: 'Inscreva-se',
      },
      plan: {
        free: {
          feature_1: 'Envie até <strong>%{transfer_limit}</strong>',
          feature_2: 'Não é necessário verificar as transferências',
          subtitle_new: 'Para remetentes ocasionais',
          title: 'Grátis',
        },
        pro: {
          feature_1: 'Envie e receba até <strong>%{transfer_limit}</strong>',
          feature_2: 'Decida quando as transferências expiram',
          feature_5: '1 TB de armazenamento por pessoa',
          subtitle_new: 'Para profissionais e equipes',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Inscreva-se já',
          descripttion: 'Monitore as transferências',
          feature_1: 'Envie até 2 GB',
          feature_2: 'Receba transferências em um só resumo',
          title: 'Grátis',
        },
        pro: {
          cta: 'Saiba mais',
          descripttion: 'Aproveite o melhor do WeTransfer',
          feature_1: 'Envia e recebe até %{transfer_size}',
          feature_2:
            '%{storage_size} de armazenamento de transferências por pessoa',
          feature_3: 'Envie transferências com configurações personalizadas',
          title: 'Pro',
        },
        title:
          'Não deixe que as transferências se percam na sua caixa de entrada.',
      },
      title: 'Desfrute ao máximo do novo WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Convidar equipe',
        pagename: 'Convidar equipe',
      },
      manage: {
        cta: 'Gerenciar equipe',
      },
      members:
        'Você tem %{amountOfMembers} membros na sua equipe. <a href="%{href}">%{cta}</a>',
      no_members: 'Por enquanto é só você! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Configurações da equipe',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Crie uma equipe e transfira em conjunto',
        context:
          'Envie e receba transferências como equipe com armazenamento compartilhado, identidade visual e acesso às transferências de todos os membros da equipe.',
        invite_team: 'Convidar equipe',
        dismiss: 'Talvez depois',
      },
      feature_highlight: {
        free_context:
          'Agora, você pode gerenciar as transferências enviadas e recebidas com um simples resumo. Saiba quando seus arquivos são baixados. Reenvie, reencaminhe ou baixe suas transferências com um clique. É simples assim',
        free_subtitle: 'Todas as suas transferências, em um só local',
        paste_collect_link:
          'Acesse <a href="%{pasteUrl}" rel="external">%{pasteName}</a> ou <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'Agora você pode enviar transferências de qualquer tamanho e criar sua própria <b>página no WeTransfer</b>, para personalizar o que as pessoas veem quando baixam os seus arquivos. Está pronto para escolher seu URL e seus fundos de tela?',
        premium_cta: 'Criar página',
        premium_dismiss: 'Talvez depois',
        premium_subtitle: 'Configure sua página no WeTransfer',
        premium_team_context:
          'Agora você pode enviar e receber transferências de qualquer tamanho a partir da página personalizada da sua equipe no WeTransfer.',
        pro_context:
          'Agora, você pode enviar até %{transfer_limit} de uma só vez e criar sua própria <b>página no WeTransfer</b> para personalizar o que as pessoas vêm quando baixam seus arquivos. Pronto para escolher o endereço do seu URL e seus fundos de tela?',
        pro_team_context:
          'Agora, você pode enviar e receber %{transfer_limit} transferências da <b>página personalizada do WeTransfer</b> da sua equipe.',
        send_cta: 'Ir para enviar arquivos',
        team_subtitle: 'Entregue o trabalho criativo como uma equipe',
      },
      marketing: {
        context:
          'Agora que já sabemos um pouco mais sobre você, adoraríamos falar um pouco sobre nós. Quer ficar informado sobre histórias criativas e as últimas novidades do WeTransfer?',
        image_alt_text:
          'Exemplo de conteúdo de e-mail, inclusive novas funções de produtos, relatórios da indústria e artigos no WePresent que contam histórias criativas.',
        opt_in: 'Sim, por favor',
        opt_out: 'Não, obrigado',
        unsubscribe:
          'Você pode cancelar a assinatura depois, não vamos ficar chateados.',
      },
      welcome: {
        context: 'Conhecer melhor você nos ajuda a melhorar nosso serviço.',
        cta: 'Continuar',
        dismiss: 'Ignorar',
        dropdown_options: {
          architecture: 'Arquitetura/construção',
          data: 'Dados/finanças/jurídico',
          design: 'Design/ilustração',
          education: 'Educação/treinamento',
          marketing: 'Marketing/RP',
          music: 'Música/som',
          other: 'Outro (e com orgulho)',
          photography: 'Fotografia',
          product: 'Produto/software',
          sales: 'Vendas/relacionamento com clientes',
          video: 'Vídeo/animação',
        },
        free_tier_title: 'Bem-vindo ao WeTransfer, %{name}!',
        placeholder: 'Hum, vamos ver...',
        question: 'Em primeiro lugar, em qual setor você trabalha?',
        team_title: 'Você está na equipe, %{name}!',
        tier_title: 'Bem-vindo ao WeTransfer %{tier}, %{name}!',
        data_opt_in: {
          checkbox_label:
            'Permitir que o WeTransfer utilize as informações que você compartilhou para apresentar anúncios personalizados para você dentro e fora dos nossos sites.',
          tooltip_anchor: 'O que significa isto?',
          tooltip: {
            title: 'Como o WeTransfer utiliza meus dados?',
            p1: 'Utilizamos seu endereço de e-mail para apresentar a você (e a outras pessoas) anúncios do WeTransfer nos sites que você visitar, como redes sociais.',
            p2: 'Também utilizamos sua área de trabalho para proporcionar uma experiência melhor nos nossos sites.',
            p3: 'Os dados que você optar por compartilhar conosco estarão sempre seguros.',
            button: 'Entendi',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Adicione outras pessoas ao seu espaço de trabalho',
      workspace: 'Espaço de trabalho',
      manage_workspace: 'Gerenciar espaço de trabalho',
    },
  },
  exception: {
    activate_subscription_exception:
      'Hmm, houve um problema - tente novamente ou entre em contato conosco por meio da nossa <a href="https://wetransfer.zendesk.com" rel="external">central de ajuda</a>',
    complete_payment_exception:
      'Hmm, houve um problema - tente novamente ou entre em contato conosco por meio da nossa <a href="https://wetransfer.zendesk.com" rel="external">central de suporte</a>',
    retrieve_checkout_exception:
      'Hmm, houve um problema - tente novamente ou entre em contato conosco por meio da nossa <a href="https://wetransfer.zendesk.com" rel="external">central de ajuda</a>',
    source_id_error: 'Não foi possível processar este pedido — tente novamente',
    three_d_secure: 'Atualmente não aceitamos cartões de seguros 3D.',
    generic_error:
      'Hum, houve um problema. Tente novamente ou entre em contato conosco pela nossa central de ajuda',
    invalid_file_error:
      'Este arquivo é muito grande, ou não está em formato png ou jpg. Tente com outra imagem',
    something_went_wrong:
      'Ocorreu um problema. Tente novamente ou entre em contato conosco pela nossa <a href="https://wetransfer.zendesk.com" rel="external">central de ajuda</a>',
    signin_no_data_exception:
      'Ocorreu um problema - verifique seu nome de usuário e sua senha e tente novamente',
    signin_exception:
      'Infelizmente, não foi possível iniciar sessão – tente novamente',
    signout_exception:
      'Parece que não foi possível terminar a sessão. Que estranho. Atualize esta página para verificar se ainda há uma sessão iniciada.',
    signup_account_error:
      'Hum, ocorreu um problema no início de sessão – verifique suas informações e tente novamente',
    retrieve_account_exception:
      'Ocorreu um problema. É chato perguntar, mas poderia tentar de novo?',
    update_account_error:
      'Não foi possível atualizar as informações da sua conta. Tente novamente.',
    retrieve_subscription_exception:
      'Não foi possível localizar suas informações de pagamento - tente novamente',
    update_subscription_exception:
      'Não foi possível localizar suas informações de pagamento - tente novamente ou entre em contato conosco por meio da nossa <a href="https://wetransfer.zendesk.com" rel="external">central de ajuda</a>',
    autorenewal_not_supported:
      'Esta conta não é compatível com a opção de renovação automática',
    email_background_upload_validation_error:
      'Este arquivo é muito grande, ou não está em formato png ou jpg. Tente com outra imagem',
    email_background_upload_validation_error_videos:
      'Este arquivo é demasiado grande, ou não está em formato png ou jpg. Tente com outra imagem',
    update_password_exception:
      'Não foi possível atualizar sua senha – tente novamente',
    retrieve_device_exception:
      'Não foi possível localizar nenhum dispositivo conectado. Tente novamente.',
    remove_device_exception: 'Não foi possível remover este dispositivo',
    renew_subscription_exception:
      'Não é possível renovar sua conta agora – tente novamente mais tarde',
    invoices_retrieve_exception:
      'Não foi possível localizar seus recibos – tente novamente',
    invoice_download_exception:
      'Não foi possível fazer download deste recibo – tente novamente',
    image_not_valid: 'Parece que não é possível carregar esta imagem',
    update_profile_error:
      'Não é possível atualizar o seu perfil – tente mais tarde',
    retrieve_profile_exception:
      'Não foi possível localizar as definições do seu perfil – tente novamente',
    s3_exception:
      'Ocorreu um problema durante o carregamento – tente novamente',
    file_size_limit_reached:
      'O arquivo é muito grande – carregue uma imagem com 3 MB ou menor',
    retrieve_transferlist_exception:
      'Não foi possível localizar sua lista de transferências',
    retrieve_transfer_exception:
      'Não foi possível localizar os detalhes da transferência',
    delete_transfer_exception: 'Não foi possível excluir esta transferência',
    delete_transfers_exception: 'Não foi possível excluir estas transferências',
    update_expiry_exception:
      'Não foi possível atualizar esta data de expiração',
    add_contact_exception: 'Não foi possível adicionar este contato',
    complete_last_order_exception: 'Não foi possível concluir seu pedido',
    edit_contact_exception: 'Não foi possível atualizar este contato',
    remove_contact_exception: 'Não foi possível excluir este contato',
    request_password_reset_exception:
      'Infelizmente, não foi possível processar este pedido de redefinição — tente novamente',
    request_password_reset_no_user:
      'Este endereço de e-mail não é reconhecido - verifique outra vez e tente novamente',
    reset_password_error:
      'Ocorreu um problema durante a redefinição da sua senha — tente novamente',
    reset_password_exception:
      'Infelizmente, não é possível redefinir sua senha neste momento — tente novamente',
    reset_password_token_invalid:
      'Este link de redefinição não funcionou — siga as instruções que te enviamos por e-mail, ou comece novamente',
    retrieve_last_order_exception: 'Não foi possível localizar seu pedido',
    retrieve_ternot_exception:
      'Hum, não conseguimos localizar sua transferência - tente novamente',
    signin_invalid_credentials:
      'Parece que este endereço de e-mail e esta senha não correspondem — verifique outra vez e tente novamente',
    unsubscribe_expiration_exception:
      'Ocorreu um problema no cancelamento da sua assinatura - tente novamente',
    unsubscribe_expiration_invalid_signature:
      'Este link para cancelar a assinatura não funcionou - tente novamente',
    cancel_subscription_exception:
      'Parece que houve um erro. Não pudemos cancelar sua assinatura. Tente novamente mais tarde.',
    payment_cancelled:
      'Hum, houve um problema. Tente novamente ou entre em contato conosco por meio da nossa <a href="https://wetransfer.zendesk.com" rel="external">central de ajuda</a>',
    profile_picture_upload_validation_error:
      'Este arquivo é muito grande, ou não está em formato png ou jpg. Tente com outra imagem',
    reactivate_subscription_exception: 'Ocorreu um erro, tente novamente',
    retrieve_contactlist_exception:
      'Não foi possível localizar sua lista de contatos',
    source_retrieve_error:
      'Hum, houve um problema. Tente novamente ou entre em contato conosco pela nossa <a href="https://wetransfer.zendesk.com" rel="external">central de ajuda</a>',
    token_error: 'Houve um problema. Quer tentar novamente?',
    update_user_error: 'Houve um problema na atualização da sua informação',
    wallpaper_upload_validation_error:
      'Este arquivo é muito grande ou não está em formato png ou jpg. Tente com outra imagem',
    wallpaper_upload_validation_error_videos:
      'Epa, parece que o seu vídeo não atende aos nossos requisitos - tente novamente',
    declined_contact_bank_error:
      'Não foi possível processar o pagamento. Entre em contato com o seu banco',
    invalid_password: 'Senha não reconhecida',
    otp_token_invalid: 'Epa, esse código está errado ou expirou',
    projects_load_exception: 'Não estamos conseguindo carregar seus projetos',
    update_information_throttle:
      'Houve um problema na atualização da sua informação. Faça uma pausa de %{throttle_time} antes de tentar novamente.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
    price_general_error_transfer_details:
      'The price could not be updated, please try again',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Produtos',
        plans_and_pricing: 'Planos e preços',
        pricing: 'Tarifas',
        pro_and_premium: 'WeTransfer Pro e Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Anunciar',
        upgrade: 'Mudar de plano',
      },
      name_1_2019: 'Empresa',
      name: 'Empresa',
    },
    accessibility: {
      aria_label: 'Principal',
    },
    home: {
      name: 'Página principal',
    },
    help: {
      name: 'Ajuda',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Transferências',
        contacts: 'Contatos',
        profile: 'Profile',
        account: 'Conta',
        received: 'Recebidas',
        sent: 'Enviadas',
        teams: 'Equipe',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Terminar sessão',
    signin: {
      name: 'Iniciar sessão',
    },
    branding: 'Desenvolvimento de marca',
    label: {
      beta: 'Beta',
      new: 'Novidades',
    },
    login: 'Entrar',
    logout: 'Sair',
    portals: 'Portais',
    signup: 'Inscreva-se',
    features: {
      name: 'Recursos',
      all: 'Todos os recursos',
      file_sharing: 'Para compartilhamento de arquivos',
      collaboration: 'Para colaboração',
      security: 'Para segurança dos dados',
      branding: 'Para branding',
      fast_feedback: 'Para receber respostas rápidas',
    },
    referral: 'Refer friends',
    switcher: {
      create_free_account: 'Adicionar gratuitamente',
      just_you: 'Somente você',
      team: 'Equipe',
      team_member_count: '%{amountOfMembers} membros',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: 'Hmm, você não está conectado à Internet',
        begins_space:
          'Não é possível enviar arquivos cujos nomes começam com um espaço. Mude o nome e tente novamente.',
        begins_stop:
          'Não é possível enviar arquivos cujos nomes começam com um ponto final. Mude o nome e tente novamente.',
        blocked:
          'Não foi possível carregar o WeTransfer – parece que você está bloqueado',
        generic: 'Infelizmente ocorreu um problema durante a transferência',
        has_blackslash:
          'Não é possível enviar arquivos cujos nomes começam com uma barra invertida. Mude o nome e tente novamente.',
        has_linebreak:
          'Não é possível enviar arquivos cujos nomes contêm uma quebra de linha. Mude o nome e tente novamente.',
        incorrect_recipient:
          'Parece que um dos endereços de e-mail que você informou está incorreto',
        incorrect_sender:
          'Parece que há um problema com o seu endereço de e-mail',
        io_error: 'Há um problema com os seus arquivos',
        long_filename:
          'Não é possível enviar arquivos cujos nomes têm mais de 250 caracteres. Mude o nome e tente novamente.',
        long_message: 'Essa mensagem é muito longa – encurte-a',
        missing_default_recipient:
          'Somente endereços de email registrados no WeTransfer podem receber mais do que %{free_transfer_limit}. Atualize a página para começar novamente.',
        no_clipboard: 'Parece que você não copiou o link',
        no_files: 'Parece que você ainda não adicionou arquivos!',
        no_folders:
          'Você precisa zipar/comprimir a pasta para podermos enviá-la',
        no_recipient:
          'Precisamos do endereço de e-mail para onde você pretende enviar os arquivos',
        no_sender:
          'Agora só falta seu endereço de e-mail para podermos continuar',
        too_big:
          'Espera aí – não é possível transferir mais de %{upload_limit} de uma vez',
        too_many_recipient:
          'Epa! - Nosso limite são %{count} pessoas. Precisa de mais? Utilize um link para a transferência.',
        unavailable:
          'Infelizmente, essa transferência foi excluída e não está mais disponível',
        wrong_password:
          'Hum, essa senha não está correta. Tente novamente ou confirme com a pessoa que enviou a transferência.',
        default_title: 'Epa!',
        duplicate_filename:
          'Não é possível enviar vários arquivos com o mesmo nome. Mude o nome e tente novamente.',
        firstaccept: 'É preciso aprovar antes de enviar',
        not_downloadable:
          'Ocorreu um problema na tentativa de obter os seus arquivos. Recarregue a página e tente novamente.',
        recaptcha: {
          text: 'Houve um problema. Tente novamente!',
          title: 'Epa...',
        },
        too_big_text:
          'Você não pode fazer transferências superiores a %{upload_limit} ao mesmo tempo. Com o Pro, você pode enviar até %{plus_limit}. ',
        too_big_title: 'Olá grande enviador',
        too_many_files:
          'Não é possível enviar %{count} arquivos ao mesmo tempo',
        too_many_recipient_text:
          'Você pode transferir arquivos para até 50 pessoas com o Pro.',
        too_many_recipient_title: 'Você selecionou pessoas demais',
        unavailable_forward:
          'Infelizmente, parece que essa transferência foi excluída, por isso não pode ser encaminhada',
        verify: {
          button: 'Envie-me outro código!',
          text: 'Tente novamente ou peça outro código. ',
          title: 'Epa!',
        },
      },
      buttons: {
        check_out: 'Confira!',
        help: 'Central de ajuda',
        plus: 'Adquira o Pro',
        get_link: 'Pegar link',
      },
      tips: {
        change_type:
          'Envie o link da transferência por email ou gere um link para compartilhar o que você deseja',
        contacts:
          'As pessoas a quem você enviar arquivos serão adicionadas automaticamente aos teus contatos',
        expiry:
          'Com o WeTransfer Pro, você decide quando suas transferências expiram (você pode até mesmo alterar a data de expiração após enviar a transferência!)',
        free_limit:
          'Boa notícia, você pode enviar até %{size} de uma vez. Melhor ainda, você pode usar o serviço quantas vezes quiser!',
        message:
          'Se quiser, escreva aqui uma mensagem para acompanhar sua transferência',
        password:
          'Para maior segurança, você pode proteger a transferência com uma senha. Observe que não vamos adicionar a senha ao e-mail, por isso você terá que informar a senha às pessoas certas!',
        recipient_limit:
          'Adicione até %{email_limit} e-mails ou abra o menu ao lado do botão de transferência para criar um link',
        transfer_history:
          'Sua transferência fica armazenada na lista de transferências',
        your_email:
          'Deixe aqui o seu endereço de e-mail para podermos notificar quando o download dos seus arquivos tiver sido feito',
        link_transfer:
          'Você sabia que podes encontrar o seu link para transferência aqui?',
        previews_receiver:
          'As imagens enviadas pelos usuários Pro podem ser vistas antes de serem baixadas.\nBasta clicar em um arquivo para ver o conteúdo!',
        previews_sender:
          'Agora, você pode ver uma prévia das imagens que enviar antes de serem baixadas',
        vrl_text: 'Agora, você pode ver seus arquivos sem ter que baixá-los.',
        vrl_title: 'Veja uma prévia dos seus arquivos',
        zip_text: 'Quer enviar um arquivo? Nós o compactamos para você',
        zip_title: 'Não é necessário compactar',
        add_display_name_tooltip:
          'Dê um título à sua transferência para que as pessoas saibam do que se trata. Isto também facilita a procura posteriormente.',
        anonymous_sender: {
          button: 'Pegar link',
          text: 'Digite o endereço do seu e-mail para informarmos você quando seus arquivos forem baixados.\n\nVocê terá que verificar o e-mail para sabermos que é realmente você. Não quer ter que fazer a verificação a cada transferência?',
          text_locked_recipient:
            'Digite aqui o endereço do seu e-mail para informarmos você quando seus arquivos forem baixados.\n\nVocê terá que verificar o seu e-mail para sabermos que é realmente você.',
        },
        prefer_link: {
          button: 'Pegar link',
          text: 'Não quer verificar seu e-mail? Não tem problema.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Saiba mais',
        previews_sender_learnmore: 'Saiba mais',
      },
      recipient_locked_text:
        'Esta página é para o proprietário receber arquivos. Acesse se for o proprietário, ou visite <a href="https://wetransfer.com">wetransfer.com</a> para enviar para outra pessoa.',
      recipient_locked_title: 'Atenção',
      title: {
        previews_receiver: 'Prévia de imagens',
        previews_sender: 'Prévia de imagens',
      },
    },
    download: {
      blocked: {
        link: 'Saiba mais',
        text: 'Esta transferência foi denunciada e não pode ser baixada',
        title: 'Transferência não disponível',
      },
      title: 'Tudo pronto',
      expires: 'A transferência expira em %{relative_time}',
      expires_never: 'Sem data de expiração',
      files: '%{count} arquivos, %{size}',
      format: '%{files}・%{expires}',
      expand: 'mais',
      download_link: 'Link para download',
      files_nosize: {
        one: '%{count} arquivo',
        other: '%{count} arquivos',
      },
      show_all_files_mobile: 'Mostrar todos os arquivos',
      zip_information:
        'Você receberá um arquivo .zip quando fizer download de todos os arquivos de uma vez só - <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">ler mais</a>',
      files_label: 'Arquivos',
      message: 'Mensagem',
      learn_more: 'saiba mais',
      expires_in: 'Expira em %{expiry}',
      download_all_zip:
        'Se optar por baixar tudo, todos os arquivos serão baixados em um arquivo .zip',
      back_to_transfer: 'Voltar à transferência',
      cookie_text:
        'Utilizamos cookies para proporcionar a melhor experiência para você. Fique tranquilo, não vendemos seus dados a terceiros. Gerencie suas <a href="https://wetransfer.com/legal/manage-cookies" rel="external">preferências sobre seus dados</a>.',
    },
    preview: {
      open_grid: 'Prévia',
      click_to_open: 'Clique para ver uma prévia',
      grid: 'Itens nesta transferência',
      link: 'Site',
      not_previewable: 'Prévia indisponível',
      now_open: 'Abrir prévia',
      open_link: 'Abrir link em uma nova guia',
      open_link_short: 'Abrir link',
      overview: 'visão geral',
      reload: 'Recarregar',
      something_went_wrong: 'Opa, ocorreu um problema',
      tap_to_open: 'Toque para ver a prévia',
      toobig_copy:
        'Somente é possível ver uma prévia de imagens com até 50 MB – <a href="https://wetransfer.zendesk.com/" rel="external">leia mais aqui</a>',
      toobig_title:
        'Ih, esta imagem é muito grande para gerarmos uma prévia dela',
      unsupported_copy:
        'Leia <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">este artigo</a> para saber para quais arquivos podemos gerar prévias',
      unsupported_title: 'Não é possível (ainda) ver uma prévia deste arquivo',
      visit_website: 'Acessar o site',
    },
    complete_mobile: {
      email_text:
        'O e-mail de transferência foi enviado. Sua transferência ficará disponível por %{expires}.',
      link_text: 'Copie o link para baixar:',
      email_text_no_expiry: 'O e-mail foi enviado para o destinatário.',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            '<b>Sabia que 30% do nosso espaço publicitário está reservado para artistas?</b> Ao aceitar nossos cookies, você permite que apresentemos um pouco de arte, algumas causas importantes para nós e algumas publicidades premiadas que não incomodam ninguém. ',
          text: 'Aceita também cookies de terceiros, nossos parceiros publicitários, para podermos personalizar os anúncios que você vê? ',
          title: 'Nossos cookies alimentam a cultura',
        },
        subtitle:
          '<b>É por isso que 30% do nosso espaço publicitário está reservado aos artistas.</b> Ao aceitar nossos cookies, você nos permitirá apresentar um pouco de arte, algumas causas importantes para nós e algumas publicidades premiadas que não incomodam ninguém. ',
        text: 'Nosso site utiliza cookies que o ajudam a funcionar corretamente, nos permitem saber como você utiliza o WeTransfer e nos ajudam a melhorar o desempenho. Aceita também cookies de terceiros, nossos parceiros publicitários, para podermos personalizar as publicidades que você vê?',
        title: 'Nós acreditamos que a arte pode mover montanhas',
        'title-small': 'Bem-vindo ao WeTransfer',
      },
      'button-accept': 'Aceito',
      'button-accept-all': 'Aceitar todos',
      'button-ccpa': 'Opte pela venda de informações pessoais',
      'button-cookies-privacy': 'Suas opções de privacidade',
      'button-reject': 'Não, obrigado',
      'button-save': 'Salvar',
      'button-save-and-exit': 'Salvar e fechar',
      'ccpa-banner-text':
        'Utilizamos cookies para garantir a melhor experiência para você no nosso site. Não tenha medo, não vendemos os seus dados a terceiros. Deseja sair assim mesmo? <a href="%{href}">Gerenciar configurações</a>',
      'ccpa-body':
        'Como você está nos EUA, seus direitos são protegidos pela Lei de Privacidade do Consumidor da Califórnia (CCPA) e você pode pedir-nos que deixemos de vender suas informações pessoais. Isto não significa que leiloemos seus dados pessoais ou arquivos privados ao licitador com a maior oferta. Nunca o fizemos e nunca o faremos! Empreendemos esforços para manter sua pegada digital pequena, segura e sob o seu controle. Leia mais sobre quais dados recolhemos e por que em <a href="%{href}">Suas opções de privacidade</a>.',
      'ccpa-donotsell': 'Não venda minhas informações pessoais',
      'ccpa-header': 'Não optar pela venda de informações pessoais',
      'ccpa-intro':
        'Como empresa tecnológica responsável empenhada por uma Internet melhor, não vendemos seus dados a terceiros. Mas, de qualquer forma, você tem o direito de optar oficialmente por não permitir.',
      'ccpa-variant-test-text':
        'Utilizamos cookies para garantir uma experiência impecável no nosso site e para personalizar a publicidade que você vê. <a href="%{href}">Gerenciar cookies</a>',
      headline: 'Cookies e publicidade',
      intro:
        'O dinheiro que ganhamos com as nossas belas peças publicitárias nos ajuda a pagar as contas. É assim que conseguimos oferecer este serviço de compartilhamento de arquivos gratuitamente.',
      'manage-cookies': 'Gerenciamento de cookies',
      'partners-consent': 'Autorização',
      'partners-features': 'Funções',
      'partners-headline': 'Nossos parceiros',
      'partners-text':
        '<p>Aqui você encontra uma lista alfabética dos parceiros selecionados com critério e que têm acesso aos seus dados, para podermos acompanhar e melhorar o desempenho.</p>',
      'preferences-headline': 'Gerenciamento de cookies ',
      'preferences-text':
        '<p>Respeitamos seu direito à privacidade e suas escolhas referentes aos seus dados. Precisamos processar alguns dos seus dados pessoais na sua utilização das nossas ferramentas, mas comprometemo-nos a assumir uma abordagem responsável e baseada em valores, tanto nos negócios e na tecnologia como na relação que temos com você.</p> \n<p>Por isso que empreendemos esforços para manter sua pegada digital pequena, segura e controlada por você.</p> \n<p>Por padrão, somente recolhemos e processamos dados quando é mesmo necessário. No entanto, se deseja apoiar nosso trabalho e ajudar a manter o WeTransfer gratuito, permita-nos compartilhar dados com os nossos parceiros publicitários.</p>',
      'preferences-text-allow-cookies':
        'Autorize os cookies, para que nós e/ou os nossos parceiros possamos:<br><br>',
      'purpose-description-first-intro':
        'Para promover produtos em nosso site, nos apps e fora deles, o WeTransfer pode: ',
      'purpose-description-first-list':
        '<ul><li>Recolher dados sobre como você interage com nossos sites, como os cliques e as páginas visitadas e (quando possível) combinar estas informações com dados que tenhamos armazenados sobre você, como o endereço de e-mail da sua conta. </li><li>Utilizar a informação que recolhemos para enviarmos ofertas e promoções por e-mail, ou em nossos próprios sites e apps; e nos sites ou apps de terceiros. Por exemplo, poderemos promover um dos nossos outros produtos quando você utilizar o WeTransfer Pro.</li></ul>',
      'purpose-description-second-intro':
        'Para promover produtos em nosso site ou nos apps e fora deles, nossos parceiros podem: ',
      'purpose-description-second-list':
        '<ul><li>Recolher dados sobre como você interage com nosso site, como os cliques e as páginas visitadas, e (quando possível) combinar essas informações com dados que tenhamos armazenados sobre você</li><li>Utilizar a informação que recolhemos para enviarmos ofertas e promoções por e-mail, ou em seus próprios sites ou apps; e nos sites ou apps de terceiros com quem trabalham.</li></ul>',
      'purpose-title':
        'Promoção de produtos em nosso site e nos apps e fora deles',
      'switch-by-partners': 'Pelos parceiros',
      'switch-by-we-transfer': 'Pelo WeTransfer',
      text: '<p>Nosso site usa <a href="%{href}">cookies</a> que ajudam em seu funcionamento, que nos permitem analisar a forma como você interage com o mesmo, e que nos ajudam a melhorar o nosso desempenho.</p> \n<p>Deseja também aceitar cookies dos nossos parceiros publicitários para podermos personalizar os anúncios que você vê, bem como promover os produtos do WeTransfer e dos nossos parceiros, tanto em nossos sites e apps como em outras plataformas?</p>',
      'text-panel':
        '<p>Nosso site usa cookies que ajudam no funcionamento, que nos permitem analisar a forma como você interage com o mesmo e que nos ajudam a melhorar o nosso desempenho.</p> \n<p>Deseja também aceitar cookies dos nossos parceiros publicitários para podermos personalizar os anúncios que você vê, bem como promover os produtos do WeTransfer e dos nossos parceiros tanto nos nossos sites e apps como em outras plataformas?</p>',
      'tos-experiment': {
        'cookie-intro':
          'A forma mais fácil de enviar arquivos grandes e ao mesmo tempo conhecer trabalhos incríveis de arte e anúncios premiados.',
        'cookie-text':
          'Nosso site usa cookies que ajudam no funcionamento, que nos permitem analisar a forma como você interage com o mesmo e que nos ajudam a melhorar o nosso desempenho.\nAo aceitar nossos cookies, você nos autoriza a apresentar publicidade personalizada. Já dissemos a palavra cookies um número suficiente de vezes? (Cookie.)',
      },
      trees: {
        'short-v': {
          subtitle:
            'Nossa missão é embelezar o mundo com anúncios premiados que não incomodam ninguém e nos ajudam a contribuir para a restauração de florestas marinhas.',
          title: 'Nossos cookies protegem o planeta',
        },
        subtitle:
          'Aceitando nossos cookies, você nos ajuda diretamente a cumprir nossa compromisso com o planeta. Só este ano, o WeTransfer comprometeu-se a plantar mais de 175 mil árvores e estamos apenas no início. Você exercerá um impacto positivo sobre o planeta somente através das nossos anúncios premiados. ',
        text: 'Nosso site utiliza cookies que nos ajudam a melhorar o desempenho, o serviço e a conhecer melhor suas necessidades. Se aceitar nossos cookies de terceiros, tanto nós como nossos parceiros publicitários poderemos oferecer anúncios mais relevantes, em nossos sites e apps e fora deles.',
        title: 'Transfira ideias. <b>Transforme o mundo.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Conheça o Collect Pro',
      title: 'Salve e compartilhe inspiração em movimento',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Quero saber mais',
      title: 'Paste® Pro e Collect Pro agora estão incluídos na sua assinatura',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Tenha acesso ao Paste® Pro',
      title: 'Transforme grandes ideias em belas apresentações',
    },
    terms_conditions: {
      experiment: {
        text: 'Para continuar, aceite nossos <a href="/legal/terms" data-route-type="plus">Termos e Condições</a>.',
        title: "Está <span class='tc-title-exp'>quase</span> lá",
        ustitle:
          "Bem-vindo ao caminho mais simples para <span class='tc-title-exp'>enviar grandes arquivos.</span>",
      },
      title: 'Para começar...',
      text: 'Aceite nossos <a href="/legal/terms" data-route-type="plus">Termos de Serviço</a> e a <a href="/legal/privacy" data-route-type="plus">Política de cookies</a>. Usamos cookies funcionais e analíticos e cookies de terceiros para publicidade.',
      language: 'Idioma definido para',
      button: 'Concordo',
    },
    upsell_pricing: {
      text: 'Comparar planos',
      title: 'Deseja enviar transferências maiores?',
      receiving: {
        title: 'Queres aproveitar o máximo a WeTransfer?',
      },
    },
    welcome: {
      card1:
        'Envie e receba %{transfer_limit} transferências com um só <strong>resumo compartilhado</strong>',
      card2:
        'Entregue trabalho a partir da <strong>página personalizada</strong> da sua equipe no WeTransfer',
      card3:
        'Colabore em apresentações no <strong>Paste®</strong> e quadros no <strong>Collect</strong>',
      cta: 'Vamos começar',
      headline: 'Você está na equipe, <strong>%{first_name}!</strong>',
      'opt-in':
        'Quero receber histórias de criatividade e notícias do WeTransfer',
    },
    form: {
      num_files: {
        one: '%{count} arquivo · Faltam %{remaining}',
        other: '%{count} arquivos adicionados · %{remaining} restantes',
      },
      add_files: 'Enviar arquivos',
      more_files: 'Adicionar mais arquivos',
      available_space: 'Adicionar até %{size}',
      message: 'Mensagem',
      from: 'Seu e-mail',
      to: 'E-mail para',
      other_recipients: {
        one: '+%{count} outro',
        other: '+%{count} outros',
      },
      reset_forward: 'Cancelar este encaminhamento',
      drop_files: 'ou arraste e solte',
      files_count: {
        one: '%{count} arquivo adicionado · %{fileSize} no total',
        other: '%{count} arquivos adicionados · %{fileSize} no total',
      },
      select_folder: 'Ou selecione uma pasta',
    },
    progress: {
      title: 'Transferindo...',
      title_finalizing_one: 'A finalizar…',
      title_finalizing_two: 'Quase pronto...',
      title_finalizing_three: 'Mais um momento...',
      title_finalizing_four: 'Terminando...',
      subtitle_finalizing:
        'Não feche esta janela até finalizarmos a transferência',
      title_cancel: 'Cancelar esta transferência?',
      uploaded: '%{sent} de %{total} enviados',
      remaining: {
        minutes: {
          zero: 'Menos de 1 minuto restante',
          one: 'Cerca de 1 minuto restante',
          other: 'Cerca de %{count} minutos restantes',
        },
        hours: {
          one: 'Cerca de 1 hora restante',
          other: 'Cerca de %{count} horas restantes',
        },
      },
      document_title: '%{percentage}% - Transferindo...',
      meta: {
        email: {
          one_file_one_recipient:
            'Enviando %{filesCount} arquivo para %{recipientsCount} pessoa',
          one_file_other_recipients:
            'Enviando %{filesCount} arquivo para %{recipientsCount} pessoas',
          other_files_one_recipient:
            'Enviando %{filesCount} arquivos para %{recipientsCount} pessoa',
          other_files_other_recipients:
            'Enviando %{filesCount} arquivos para %{recipientsCount} pessoas',
        },
        link: {
          one: 'Enviando %{count} arquivo',
          other: 'Enviando %{count} arquivos',
        },
      },
    },
    complete_link: {
      title: 'Pronto!',
      text: 'Copia o link para download ou <a href="/transfer/progress">veja uma prévia</a>',
      text_copied: 'O link foi copiado para sua área de transferência',
      text_manual_copy:
        'Seu link está pronto\nPressione %{shortcut} para copiar para a área de transferência',
      document_title: 'Pronto!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Sua transferência foi encaminhada',
    },
    complete_email: {
      title: 'Pronto!',
      text: 'O e-mail de transferência foi enviado. Sua transferência está disponível por %{expires}. <a href="/transfer/progress">Veja o que há dentro</a>',
      text_no_expiry:
        'O e-mail de transferência foi enviado. <a href="/transfer/progress">Ver prévia</a>',
      document_title: 'Enviado!',
      text_no_details:
        'O e-mail de transferência foi enviado - sua transferência ficará disponível por %{expires}.',
      team_discovery_title: 'Transferência enviada!',
      team_discovery_text:
        'Sua transferência ficará disponível para download por %{expires}',
    },
    failed: {
      title: 'Epa, ocorreu um erro',
      text: 'Parece que a sua transferência não foi realizada. Tente novamente',
    },
    pending: {
      title: 'Estamos quase lá...',
      subtitle: 'Preparando...',
    },
    downloading: {
      title: 'Pegando seus arquivos..',
      text: 'Estamos preparando o seu download',
    },
    downloaded: {
      title: 'Seu download começou',
      text: 'Quando terminado, os arquivos estarão no seu computador ( normalmente na pasta de downloads).',
      download_links:
        'Esteja ciente de que os links deste quadro não vão aparecer - <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">leia mais aqui</a>.',
    },
    expired: {
      title: 'Transferência expirada',
      text: 'A transferência expirou e não está mais disponível',
    },
    password: {
      title: 'Informar senha',
      text: 'É preciso uma senha para fazer o download desta transferência',
    },
    options: {
      transfer_type: 'Enviar como',
      password: 'Senha',
      password_placeholder: 'Definir senha',
      expiry: 'Expira após',
      expire_in: {
        '1w': '1 semana',
        '2w': '2 semanas',
        '1m': '4 semanas',
        never: 'Nunca',
        '14d': '2 semanas',
        '28d': '4 semanas',
        '365d': '1 ano',
        '7d': '1 semana',
        '90d': '3 meses',
      },
      email: 'e-mail',
      link: 'link',
      email_transfer: 'Enviar transferência por e-mail',
      transfer_link: 'Pegue o link de transferência',
      appearence: 'Aparência',
      set_custom_wallpaper: 'Definir papel de fundo personalizado',
    },
    buttons: {
      transfer: 'Transferir',
      forward: 'Encaminhar',
      new_transfer: 'Enviar um arquivo?',
      cancel: 'Cancelar',
      cancel_no: 'Não',
      cancel_yes: 'Sim',
      copy_link: 'Copiar link',
      ok: 'Ok',
      done: 'Enviar outro?',
      team_discovery_done: 'Enviar outra transferência',
      retry: 'Tentar novamente',
      continue: 'Continuar',
      download: 'Download',
      download_all: 'Baixar tudo',
      back_to_home: 'Voltar à página principal',
      cleanup: 'Analisar as transferências ',
      download_all_files: 'Fazer download de todos os arquivos',
      help: 'Central de ajuda',
      payment: 'Renovar agora',
      complete_order: 'Finalizar compra',
      download_all_experiment: 'Baixar tudo como um .zip',
      download_experiment: 'Baixar arquivo',
      download_file: 'Baixar arquivo',
      download_zip: 'Baixar como arquivo .zip',
      get_link: 'Pegar link',
      go_to_transfer: 'Ir para a transferência',
      openinapp: 'Salvar com o app Wetransfer',
      openinapp_experiment: 'Salvar com o app Wetransfer',
      openincollectapp: 'Salvar com o app Collect',
      get_a_link: 'Pegar link',
    },
    account_expired: {
      text: 'Renove agora para continuar desfrutando de todas as vantagens da sua conta Pro, ou <a href="#signout">encerre a sessão para usar o nosso serviço gratuito</a>',
      title: 'Sua conta Pro expirou',
    },
    invalid: {
      text: 'Não foi possível localizar seus arquivos',
      title: 'Opa...',
      link: 'Saiba mais',
    },
    outdated_browser: {
      text: 'O WeTransfer é compatível com uma ampla variedade de navegadores, mas parece que este é antigo demais. Atualize seu navegador',
      title: 'Seu navegador está desatualizado',
    },
    spam: {
      text: 'Esta transferência foi considerada spam e foi excluída',
      title: 'Hmm...',
    },
    upsell: {
      text: 'Aumentar limite',
      limit: 'Até %{limit} grátis',
      remaining: '%{remaining} restantes',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Adquira o WeTransfer Pro',
      title: 'Transferências protegidas com senha para maior segurança',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Adquira o WeTransfer Pro',
      title:
        'Uma maneira mais fácil e inteligente de gerenciar suas transferências',
    },
    upsell_one: {
      bubble: {
        button: 'Tenha o Pro',
        text: 'Proteja suas transferências com uma senha e escolha uma data de validade',
        title: 'Upgrade de transferência?',
        text_experiment:
          'Com o Pro, você pode definir senhas e datas de validade para as transferências.',
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer no Facebook',
      title: 'Participe da comunidade WeTransfer no Facebook',
    },
    custom_wallpaper_upsell: {
      text: 'Impress your clients by showcasing your work in the background.',
      title: 'Set a unique wallpaper for each transfer',
      button: 'Upgrade to Premium',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Adquira o WeTransfer Pro',
      title: 'Personalize o seu perfil no WeTransfer',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Adquira o WeTransfer Pro',
      title: 'Cresça, fique melhor, mais forte, mais rápido',
    },
    account_inactive: {
      text: 'Faça seu cadastro para começar a usar o Pro',
      title: 'Sua conta ainda\nnão está ativa',
      tiers: {
        text: 'Conclua o pagamento para começar a usar o %{plan}.',
        title: 'Sua assinatura não está ativa ainda',
      },
    },
    add_items: {
      files: 'Arquivos',
      folders: 'Pastas',
    },
    complete: {
      open_panel: '<a href="/transfer/progress">Veja o que há dentro</a>',
    },
    details: {
      button: {
        dismiss: 'Ignorar',
      },
    },
    download_preview: 'Baixar arquivo',
    error: {
      expired: {
        link: 'Fale com a nossa equipe de suporte.',
        text: 'Parece que a sua transferência já expirou.\nAcha que está errado?',
        title: 'A transferência expirou',
      },
    },
    item: {
      details: {
        folder: 'Pasta',
      },
    },
    items: {
      zero: 'vazio',
      one: '%{count} artigo',
      other: '%{count} artigos',
    },
    mobile: {
      button: {
        back: 'Voltar',
        cancel: 'Recomeçar',
        next: 'Próximo',
      },
      email: {
        title: 'Adicionar endereços de e-mail',
      },
      message: {
        placeholder: 'Adicione uma mensagem à sua transferência',
        title: 'Mensagem',
      },
      options: {
        email: 'Enviar um e-mail',
        'email-description':
          'Envie a sua transferência por um e-mail simples e informaremos você quando ela for baixada.',
        link: 'Pegar link',
        'link-description':
          'Transforme seus arquivos em links e compartilhe-os como preferir.',
      },
    },
    recaptcha: {
      button: 'Sou 100% humano',
      text: 'Só precisamos confirmar que você não é um robô (sem ofensa)',
      title: 'Quase tudo pronto!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Ajude-nos',
      title: 'Podemos fazer algumas perguntas sobre a sua forma de trabalhar?',
    },
    'verification-code': 'Código de verificação',
    verify: {
      button: 'Iniciar transferência',
      text: 'Veja se recebeu o código de verificação na sua caixa de entrada e digite-o abaixo',
      title: 'Você recebeu um e-mail',
      'verification-code': 'Código de verificação',
    },
    'account-verification-failed': {
      body: 'Estamos com dificuldade para confirmar o seu e-mail. Envie um novo link para tentar novamente.',
      cta: 'Enviar um novo link?',
      title: 'Ocorreu um erro',
    },
    'cookie-banner': {
      'button-accept': 'Ok',
      'button-decline': 'Não',
      text: 'Utilizamos <a href="%{href}">cookies</a> que viabilizam o bom funcionamento do site, nos permitem analisar a forma como as pessoas interagem com ele, e nos ajudam a aperfeiçoá-lo. Quer ativar cookies de terceiros para receber publicidade personalizada?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Utilizamos cookies de análises para nos ajudar a entender como você usa a WeTransfer. Eles nos permitem aplicar testes A/B a novos recursos, confirmar que tudo está funcionando como deveria e bloquear bots e comportamentos maliciosos como o spam. Entre esses cookies podem estar os de terceiros que processam informações pessoais. ',
        title: 'Cookies analíticos',
      },
      clear: {
        'clear-all-cookies': 'Apagar todos os cookies',
        description:
          'Você pode remover todos os seus dados dos nossos cookies. Para solicitar anonimato permanente, entre em <a href="mailto:support@wetransfer.com">contato com a nossa equipe de suporte.</a>',
        title: 'Apagar cookies',
        warning:
          'Você será desconectado da WeTransfer quando apagar os cookies. Isto não afetará as transferências na sua conta.',
      },
      functional: {
        description:
          'Utilizamos cookies funcionais para você ter uma experiência sem percalços na WeTransfer. Eles são obrigatórios para uso do nosso serviço.',
        title: 'Cookies funcionais',
      },
      'not-yet-set':
        'Parece que você ainda não nos informou suas preferência sobre cookies. Feche este painel e configure suas preferências. Você pode alterá-las aqui depois quando quiser.',
      'save-and-reload': 'Salvar configurações',
      tracking: {
        description:
          'Utilizamos cookies de publicidade no nosso serviço para nos ajudar a medir o sucesso de nossas ações comerciais, editoriais e promocionais. Os cookies de publicidade não são colocados em páginas que disponibilizam informações sobre a nossa marca e produtos. Os cookies de publicidade nos permitem registar, por exemplo, que você clicou em um determinado anúncio. Se os cookies colocados por terceiros forem colocados também em outros domínios e sites, podem permitir que os anunciantes monitorem o seu comportamento pela internet, mas a WeTransfer não tem acesso nem pode usar nenhuma destas informações pessoais que possam ser colhidas. Dessa forma, recomendamos que leia as políticas de privacidade relevantes dos terceiros.',
        title: 'Cookies de publicidade',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Opa, ocorreu um problema',
        'error-email-exists': 'Opa, parece que este e-mail já foi usado',
        'throttle-error':
          'Uau, já enviamos e-mails demais para você. Aguarde %{throttle_time} para solicitar um novo código.',
      },
      back: 'Retornar à verificação com código',
      body: 'Acertamos? É este e-mail que você está utilizando na WeTransfer.',
      email: 'E-mail',
      error: 'Opa, ocorreu um problema',
      'error-email-exists': 'Opa, parece que este e-mail já foi usado',
      submit: 'Reenviar',
      'throttle-error':
        'Desculpe, você fez muitas tentativas. Reinicie sua transferência.',
      'throttle-error-action': 'Recomeçar',
      'throttle-error-link':
        'Uau, já enviamos e-mails demais para você. Aguarde %{throttle_time} para solicitar um novo e-mail.',
      title: 'Verifique o seu e-mail',
    },
    'email-verification-success': {
      body: 'Agora, as pessoas sabem que as suas transferências foram realmente enviadas por você.',
      free_signup: 'Criar uma conta gratuita',
      onboarding_body:
        'Muito bem, você se inscrever! Pronto para escolher seu endereço e fundos de tela?',
      onboarding_title: 'Bem-vindo ao<br/>WeTransfer Pro!',
      send_files: 'Enviar arquivos',
      start_onboarding: 'Vamos lá',
      title: 'Sua conta foi verificada!',
      upsell:
        'Não quer verificar o e-mail sempre que precisar enviar um arquivo?',
      verified_sender_tooltip:
        'Seu e-mail foi verificado, com isso as pessoas podem confiar nas transferências que você enviar. Para alterar este e-mail, atualize suas <a href="%{href}">informações pessoais</a>.',
      verified_sender_tooltip_icon:
        'O endereço do seu e-mail foi verificado. Com isto as pessoas confiarão nas transferências enviadas por você.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Opa, este código está errado ou expirou. Os códigos só ficam ativos durante %{expiry_time} após terem sido enviados.',
        'error-expiry-time-action': 'Receber novo código',
        'throttle-error':
          'Você digitou um código errado ou expirado muitas vezes. Aguarde %{throttle_time} para solicitar um novo código.',
      },
      back: 'Voltar',
      body: 'Enviamos um código de verificação para <strong title="%{account_email}">%{account_email}</strong> para termos certeza de que é realmente você. (Lembre-se de ver na sua pasta de spam).',
      body_link:
        'Só uma verificação rápida para confirmar que é você.<br/><br/>Enviamos um link de verificação para <strong title="%{account_email}">%{account_email}</strong> (se não o encontrar a mensagem, verifique na sua pasta de spam).',
      error: 'Opa, este código está errado ou não é mais válido',
      'error-expiry-time':
        'Opa, este código está errado ou expirou. Os códigos só ficam ativos durante %{expiry_time} após terem sido enviados.',
      'error-expiry-time-action': 'Receber novo código',
      resend: 'Não recebeu o e-mail?',
      submit: 'Verificar',
      'throttle-error':
        'Desculpe, você fez muitas tentativas. Reinicie sua transferência.',
      'throttle-error-action': 'Recomeçar',
      title: 'Confirme seu e-mail',
      'verification-code': 'Insira o código de verificação',
    },
    'force-account-verification': {
      body: 'Vamos enviar um link para o seu e-mail para confirmar o endereço que você está usando na WeTransfer.',
      cta: 'Enviar e-mail',
    },
    'marketing-email-prompt': {
      body: 'Mais uma coisa, quer receber novidades e informações de produtos da WeTransfer?',
      skip: 'Não, obrigado',
      subscribe: 'Sim, quero ficar informado',
      title: 'Verificação feita!',
    },
    'terms_conditions-no-cookies': {
      text: 'Para prosseguir, aceite nossos <a href="/legal/terms?from_home" data-route-type="plus">Termos de Serviço</a>.',
    },
    mobile_web: {
      ios_banner_prompt: 'Pegue seus arquivos no app do WeTransfer',
      ios_banner_prompt_send: 'Envie arquivos de forma rápida e fácil',
      tnc_subtitle: 'A forma mais simples de enviar arquivos grandes',
    },
  },
  account: {
    legend: {
      plan: 'Plano',
      save: 'economize %{amount}%',
      subscription: 'Assinatura',
      summary: 'Resumo do pedido',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'Porque te estamos pedindo que confirme o seu e-mail',
    workspace: {
      default_workspace: 'Espaço de trabalho de %{name}',
      your_workspace: 'Seu espaço de trabalho',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Suas opções de privacidade',
        subtitle: 'Gerencie seus dados',
        p1: 'Queremos que tenha sempre a melhor experiência possível, mesmo quando se trata da nossa publicidade.',
        p2: 'Gostaríamos de compartilhar os dados que você nos autorizar a compartilhar, como o endereço do seu e-mail, para entendermos qual é o tipo de conteúdo que você prefere e utilizar essa informação para apresentar para você (e para outras pessoas como você) anúncios do WeTransfer mais personalizados.',
        p3: 'Tudo o que você cria e compartilha com o WeTransfer é privado. Não lemos nem utilizamos essas informações para fins de publicidade.',
        p4: 'Se optar por compartilhar estas informações conosco, elas continuarão protegidas.',
        control_label:
          'Permita que o WeTransfer utilize os dados que você compartilhar, como o seu e-mail e a sua área de trabalho, para personalizar os anúncios que você vê dentro e fora dos nossos sites.',
      },
      vertical_nav: {
        terms_of_service: 'Termos de Serviço',
        privacy_and_cookie_statement: 'Declaração de Privacidade e Cookies',
        your_privacy_choices: 'Suas opções de privacidade',
        notice_and_takedown_policy: 'Política de Aviso e Desativação',
        responsible_disclosure_policy: 'Política de Divulgação Responsável',
        advertising_terms_and_conditions: 'Termos e Condições de Publicidade',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Feche e vá enviar arquivos',
  },
  account_start_screen: {
    'collect-description':
      'Guarde toda a sua inspiração num só lugar, não importa se vai ser no celular, no notebook ou no tablet.',
    'collect-title': 'Acessar Collect',
    'paste-description':
      'Crie belos slides em poucos segundos com apresentações que criam seus próprios designs.',
    'paste-title': 'Acessar o Paste®',
    title: 'Três ferramentas. Uma conta. Infinitas possibilidades.',
    'transfer-cta': 'Vamos lá',
    'transfer-description':
      'Cria uma impressão marcante sempre que alguém baixar seus arquivos. Tudo pronto para escolher seu próprio URL e seus fundos de tela?',
    'transfer-title': 'Configure sua própria página no WeTransfer',
  },
  account_welcome_screen: {
    'pro-title': 'Bem-vindo à WeTransfer Pro, <strong>%{name}!</strong>',
    accept: 'Sim, eu quero',
    'accept-short': 'Ok',
    body_1:
      'Quer ficar por dentro das histórias sobre criatividade e das últimas novidades do WeTransfer?',
    body_2: '(Você pode cancelar esta opção depois.)',
    decline: 'Não, obrigado',
    'decline-short': 'Não, obrigado',
    title: 'Bem-vindo ao WeTransfer, <strong>%{name}!</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Aceitar cookies',
      deny: 'Negar cookies',
      manage: 'Gerenciar cookies',
    },
    description:
      'Usamos cookies regulares e cookies analíticos para garantir uma ótima experiência e cookies de terceiros para fins publicitários.',
    heading: 'Conheça a forma mais simples de enviar grandes arquivos',
    snippet: 'Bem-vindo à WeTransfer',
  },
  dropzone: {
    pro: {
      title: "<span>Drop</span> it<br>like it's hot",
    },
    title: "Drop it like it's hot",
    text: 'Carregue arquivos ou pastas soltando-os nesta janela',
  },
  form: {
    account: {
      billing_address: 'Endereço de cobrança',
      billing_cta: 'Ir para o pagamento',
      billing_title: 'Dados de cobrança',
      legend: {
        details: 'Your billing information',
        coupon_code: 'Add a discount code',
        free_plus: 'Get your free WeTransfer account',
      },
      label: {
        year_label: 'Annual',
        year_sublabel: 'Best value: save %{discount_rate}%!',
        month_label: 'Monthly',
        month_sublabel: 'Recurring billing',
        email: 'Endereço de e-mail',
        not_required: '(opcional)',
        current_password: 'Current password',
        new_password: 'New password',
        repeat_new_password: 'Confirm new password',
        password: 'Senha',
        password_confirm: 'Confirm password',
        full_name: 'Full name',
        company: 'Empresa',
        street_and_number: 'Endereço',
        city: 'Cidade',
        zipcode: 'Código postal',
        country_code: 'País',
        vat_number: 'IVA',
        coupon_code: 'Discount code',
        family_name: 'Sobrenome',
        given_name: 'Nome',
        state_code: 'Estado',
      },
      description: {
        password: 'Select a password that contains at least 6 characters',
        vat_number:
          'No caso das empresas localizadas nos Países Baixos, cobramos o IVA com taxa de 21%. Se a sua empresa se encontra em qualquer outro país da UE, informe os dados da empresa, bem como o NIF, para removermos o IVA da fatura. \n \nSe sua empresa se encontra fora da zona abrangida pelo IVA dos países da UE, precisamos das suas informações de faturamento da mesma forma, mas não cobraremos IVA.',
      },
      error: {
        email: {
          blank: 'Please enter your email address',
          invalid: 'Please enter a valid email address',
          taken: 'This email address is already in use',
          taken_login:
            'Looks like you already have an account. <a class="form-notification__message-link" href="%{login_url}">Log in?</a>',
        },
        current_password: {
          invalid: 'Password not recognized',
          blank: 'Please enter your current password',
        },
        password: {
          blank: 'Please enter your new password',
          too_short: 'Your password must contain at least 6 characters',
        },
        password_confirm: {
          blank: 'Please confirm your new password',
          confirm: "These passwords don't seem to match",
        },
        full_name: {
          blank: 'Please enter your full name',
          too_short: 'Oops, your name needs at least 3 characters (sorry JT)',
        },
        street_and_number: {
          blank: 'Please enter your address',
        },
        city: {
          blank: 'Please enter your city',
        },
        zipcode: {
          blank: 'Please enter your zip code',
        },
        country_code: {
          inclusion:
            'Verifique se não há erros de digitação ou escolha outro país',
          blank: 'Please enter your country',
        },
        state_code: {
          inclusion: 'Isso é um estado?',
        },
        vat_number: {
          vat_number: 'Informe um NIF válido',
        },
        terms_of_service: {
          accepted: 'Please accept our Terms of Service to continue',
        },
        no_results: 'Verifique a ortografia ou escolha outro país',
        convert: {
          expired:
            'Infelizmente, esta transferência já expirou e agora não pode ser salva. Você sabia que com o WeTransfer Pro você pode manter as transferências durante o tempo que quiser? Saiba mais aqui.',
        },
        coupon_code: {
          coupon_code: 'Please enter a valid discount code',
        },
        no_state_results: 'Isso é um estado?',
      },
      complete_order: 'Conclua o pedido',
      terms_conditions:
        'Aceito os <a href="/legal/terms" %{options}>Termos de Serviço</a>e li a <a href="/legal/privacy" %{options}>Declaração de Privacidade e de Cookies</a>',
      signup_for_plus: 'Inscreva-se no WeTransfer Pro',
      account_cta: 'Vamos lá',
      signup_for_account: 'Abre uma conta no WeTransfer',
      'email-verification-not-verified-link':
        'Confirme seu endereço de e-mail. Consulte o e-mail que enviamos, ou <button type="button" class="button button--link">solicite outro e-mail</button>.',
      'email-verification-resend': {
        error: 'Epa, ocorreu um erro',
        info: 'Novo código enviado! Consulte sua caixa de entrada',
        info_link: 'Novo e-mail enviado! Consulte sua caixa de entrada',
        'throttle-error':
          'Uau, já enviamos e-mails demais. Aguarde %{throttle_time} antes de solicitar outro código.',
      },
      'force-account-verification': {
        message:
          'Verifique seu endereço de e-mail para confirmar que é mesmo você.',
      },
      marketing_opt_in: 'Quero receber novidades e atualizações do WeTransfer',
      sso: {
        header: 'Dados pessoais',
        password_reset: {
          button: 'Enviar e-mail',
          instructions:
            'Você precisa alterar a (senha)? Nós ajudamos. Basta clicar no botão abaixo e enviaremos um e-mail para <span>%{email}</span> com um link para alterar a sua senha.',
          success: 'E-mail enviado! Verifique sua caixa de entrada.',
          title: 'Altere sua senha',
        },
        wrong_user: 'Não é você? Sair',
      },
    },
    payment_cancel: {
      submit: 'Confirmar',
      client_request:
        'Um cliente tinha pedido para eu utilizar o WeTransfer, mas agora não preciso mais',
      different_tool: 'Encontrei outra plataforma',
      extra_features: 'Preciso de recursos que esta assinatura não oferece',
      not_enough_storage: 'Não há espaço suficiente para mim',
      not_often_large_files:
        'Não envio frequentemente arquivos de grandes dimensões',
      other: 'Outro',
      other_more: 'Poderia nos contar mais?',
      skip: 'Ignorar e cancelar a assinatura',
      temp_project:
        'Eu só precisava enviar arquivos de grandes dimensões para um projeto temporário',
      too_expensive: 'Acho muito caro',
    },
    payment_cancel_reason: {
      skip: 'Não quero enviar comentários',
    },
    profile: {
      label: {
        profile_title: 'Nome do perfil',
        wallpaper_link: 'Link do seu site pessoal ou do seu negócio',
      },
      error: {
        subdomain_name: {
          too_short:
            'Sabemos que menos é mais, mas seu URL personalizado no WeTransfer deve ter no mínimo dois caracteres',
          domain_name: 'Esse nome já existe',
          invalid:
            'Isso é muito estranho, seu URL personalizado do WeTransfer pode conter somente letras e dígitos (ou um hífen, se for algo intermediário)',
          taken: 'Esse nome já existe',
        },
        subdomain: {
          too_short: 'É preciso ter no mínimo dois caracteres',
          too_long: 'Opa, é preciso ter no máximo 63 caracteres',
          invalid:
            'Isso é muito estranho. Seu URL do WeTransfer pode conter somente letras e dígitos (e um travessão entre dois segmentos)',
          domain_name: 'Este URL já foi escolhido',
          taken: 'Este URL já foi escolhido',
        },
        default_recipient_email: {
          invalid: 'Informe um endereço de e-mail válido',
        },
        wallpaper_link: {
          invalid: 'Informe um endereço da web válido',
        },
      },
      success: {
        subdomain: {
          updated: 'Seu URL foi atualizado',
          available: 'Boa notícia, este URL está disponível',
        },
      },
      change_background: 'Enviar imagem',
      delete_avatar: 'Excluir avatar',
      delete_background: 'Excluir imagem',
      description: {
        title:
          'Deve ter no máximo 1590 caracteres para nada ser cortado da página',
        wallpaper_link:
          'Um clique na imagem de fundo da página abre este site em outra aba.',
        recipient_email_locked:
          'Os arquivos enviados por meio do seu perfil serão enviados somente para esse endereço de e-mail',
      },
      upload_avatar: 'Enviar avatar',
      use_email_background_checkbox_label:
        'Usar esta imagem de fundo para todas as transferências enviadas por meio do meu perfil',
      account_email_checkbox: 'Mostrar e-mail no perfil',
      default_recipient_email_info:
        'Você pode modificar este endereço de e-mail nos seus <a href="/account">dados pessoais</a>',
      change_subdomain: {
        message:
          'Deseja alterar o URL para <a href="%{url}">%{subdomain}.wetransfer.com</a>? O anterior ficará disponível para outras pessoas imediatamente.',
        confirm: 'Sim, alterar URL',
        cancel: 'Voltar',
      },
    },
    fill_in_password: 'Informe sua senha para salvar estas alterações',
    select_all: 'Selecionar tudo',
    deselect_all: 'Cancelar seleção',
    save_changes: 'Salvar alterações',
    save: 'Salvar',
    submitting: 'Enviando...',
    cancel: 'Cancelar',
    forward: 'Encaminhar',
    proceed: 'Continuar',
    delete: 'Excluir',
    onboarding: {
      placeholder: {
        subdomain_name: 'escolha-um-bom-nome',
      },
      validated: {
        subdomain_name: 'Boa notícia – este domínio está disponível',
      },
    },
    confirm_leave:
      'Deseja mesmo sair desta página e perder as alterações não salvas?',
    unsaved_changes:
      'Deseja sair da página? Você perderá as alterações não salvas.',
    contact: {
      add_contact: 'Adicionar contato',
      error: {
        email: {
          duplicate: 'Este endereço de e-mail já está na sua lista de contatos',
          invalid: 'Please enter a valid email address',
        },
      },
      label: {
        company: 'Empresa',
        email: 'Endereço de e-mail',
        name: 'Nome',
      },
    },
    error: {
      current_password: {
        blank: 'Please enter your current password',
        invalid: 'Password not recognized',
      },
      email: {
        blank: 'Please enter your email address',
        duplicate: 'Este endereço de e-mail já está na sua lista de contatos',
        invalid: 'Informe um endereço de e-mail válido',
        taken: 'This email address is already in use',
      },
    },
    leave: 'Sair',
    resetpassword: {
      button: {
        request_submit: 'Email me',
        reset_submit: 'Save new password',
      },
      label: {
        confirm_new_password: 'Confirm new password',
        email: 'Endereço de e-mail',
        new_password: 'New password',
      },
      legend: {
        request_description:
          "Locked out? We'll send you instructions to reset your password and get you back on track.",
        request_title: 'Forgot your password?',
        reset_description: 'Enter a new password to get yourself back in',
        reset_title: 'Set a new password',
        request_description_success_or_article:
          'If you have a WeTransfer account, we’ve sent you instructions to reset your password. Check out this <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">Help Center article</a> if you don’t get an email from us in the next few minutes.',
      },
    },
    signin: {
      button: {
        submit: 'Acessar',
      },
      label: {
        email: 'Endereço de e-mail',
        password: 'Senha',
        remember_me: 'Remember me',
      },
      link: {
        forgot_password: 'Esqueceu a senha?',
      },
      title: 'Acessar',
    },
    stay_on_page: 'Permanecer na página',
    close_panel: 'Close',
    go_back: 'Voltar',
    labels: {
      email: 'Endereço de e-mail',
    },
    plan: {
      change: {
        month: 'Mensal (%{currency} %{price})',
        title: 'Mudar de plano',
        year: 'Anual (%{currency} %{price})',
      },
      change_plan: 'Mudar plano de pagamento',
      month: {
        copy: 'Recurring billing',
        label: 'Monthly',
        'label-payment': 'Monthly payment',
        'sub-label': 'One bill, every month',
        title: 'WeTransfer Pro: Monthly payment',
      },
      title: 'Give your ideas the premium treatment they deserve',
      year: {
        discount: 'Economize %{rate}% (que bom)',
        'label-payment': 'Yearly payment',
        'sub-label': 'That’s a 17% saving. Zing',
        title: 'WeTransfer Pro: Yearly payment',
      },
      your_order: 'Your order',
    },
    save_and_continue: 'Save and continue',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Enter your password to continue',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Agora não',
        true: 'Abrir no app WeTransfer',
      },
      headline: 'Por que não pensar grande?',
      headline2: 'Quer visualizar arquivos no app?',
      subheader: 'Envie e receba 200 GB com o WeTransfer Pro',
      subheader2:
        'Visualize os arquivos antes de transferi-los. Envie e receba transferências, controle as transferências e receba notificações.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Renove agora para continuar a usufruir de todas as vantagens da sua conta %{tier}',
      account_expired_title_tier: 'Sua conta %{tier} expirou',
      account_inactive_title_tier: 'Tudo pronto para mudar para o %{tier}',
      account_inactive_action: 'Sim, prosseguir',
      account_inactive_subtitle:
        'Só mais um passo e pronto. Mudou de ideia? Tudo bem',
      account_inactive_title: 'Pronto para passar para o Pro?',
      account_subscription_action: 'Renovar agora',
      account_subscription_expired: 'Sua conta Pro expirou',
      account_subscription_subtitle:
        'Renove agora para manter suas transferências, papeis de parede pessoais e o endereço da web. Caso contrário, eles serão excluídos em breve.',
      account_expired_action: 'Renovar agora',
      account_expired_subtitle:
        'Renove agora para continuar desfrutando de todas as vantagens da conta Pro',
      account_expired_title: 'Sua conta Pro expirou',
      expired_transfer_subtitle:
        'Os arquivos não estão mais disponíveis. Remova as informações do resumo das suas transferências <a>aqui</a>.',
      expired_transfer_title: 'Esta transferência expirou',
      account_email_verify_logged_out: 'Acesse para verificar seu e-mail',
      account_inactive_sublink: 'cancele seu pedido.',
      email_unverified_mobile_cta: 'Pronto para verificar',
      email_unverified_text:
        "Enviamos um código de verificação para %{email}. <a href='%{href}'>Não foi você?</a>",
      email_unverified_text_link:
        "Enviamos um e-mail para %{email}. <a href='%{href}'>Não foi você?</a>",
      email_unverified_title: 'Verifique seu endereço de e-mail',
      'force-account-verification': {
        body: 'Vamos enviar um link para o seu e-mail para confirmar que é você mesmo.',
      },
      'receiving-email':
        'Atenção! Substituímos %{receiving_email} no seu perfil. Isto significa que as novas transferências somente aparecerão no resumo das suas transferências se forem enviadas para %{account_email}. Para alterar esta opção, atualize suas <a href="/account">informações pessoais</a> a qualquer momento.',
    },
    design:
      'Você já deve ter percebido que fizemos algumas alterações por aqui. Muitas delas referem-se a desejos que você expressou. Por isso, divirta-se explorando o site novo e (ousamos dizer) melhor, e envie-nos sua opinião.',
    loading_error:
      'Parece que esta página está tendo problemas para carregar.\nVamos continuar tentando, ou <a href="%{path}">tenta atualizá-la</a> manualmente.',
    redesign_notice:
      'Você já deve ter percebido que <a href="/about/redesign">fizemos algumas alterações</a> por aqui. Muitas delas referem-se a desejos que você expressou. Por isso, divirta-se explorando o site novo e (ousamos dizer) melhor, e <a href="/contact" rel="external">envie-nos sua opinião<a/>.',
    return_to: 'retornar para %{pageName}',
    close: 'Fechar painel',
    cookie: {
      accept: 'Ok',
      text: 'Nós utilizamos cookies. Leia <a href="/legal/terms">os documentos legais</a> (receitas não incluídas).',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Trabalhos',
      press: 'Imprensa',
      terms: 'Termos',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Fazer upgrade',
    free_limit:
      'Você não pode enviar mais do que 2 GB de uma só vez. Deseja enviar fazer transferências maiores?',
    compare_plans: {
      button: 'Comparar planos',
      text: 'Você pode fazer o upgrade do seu plano para transferir mais de 2 GB de cada vez.',
      title: 'Tem mais arquivos para enviar?',
    },
    mobile: {
      cta: 'Saiba mais',
      header: 'Tenha o melhor do WeTransfer',
      upsell_enjoy: 'Desfrute de mais espaço de armazenamento',
      upsell_one: 'Envie transferências maiores',
      upsell_two: 'Personalize sua página do WeTransfer',
    },
    pro_limit:
      'Você não pode enviar mais do que 200 GB de uma só vez. Quer enviar transferências de qualquer tamanho?',
  },
  upsell_tiers_one: {
    text: 'Deseja configurar senhas e datas de expiração para as suas transferências?',
  },
  upsell_tiers_three: {
    text: 'Deseja enviar transferências para mais de %{email_limit} endereços de uma só vez?',
    title: 'Já é o bastante',
  },
  browser: {
    assets_failed: {
      text: 'Não foi possível carregar algumas partes importantes do nosso site.\nElas podem ter sido bloqueadas pelo seu firewall, proxy ou configuração do navegador. Experimente atualizar a página ou entre em contato com a nossa <a href="https://wetransfer.zendesk.com" rel="external">central de ajuda</a>',
      title: 'Ah, não...',
    },
    javascript_needed:
      'Para usar o WeTransfer, você precisa de um navegador compatível com JavaScript',
  },
  languages: {
    en: 'English',
    nl: 'Nederlands',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'This offer is available until %{end_date}. The discount applies on your first year of %{user_tier}, after which the subscription will renew at the full price of %{yearly_amount}/%{billing_period}.',
    },
    modal: {
      title: '%{discount_amount}% off annual Pro',
      subtitle: 'Discount code: %{coupon_code_name}',
      text_content:
        'That’s it. That’s the deal. We’re giving you a %{discount_amount}% discount on an annual Pro plan.',
      argument: {
        size_limit:
          'Você pode enviar e receber transferências de arquivos de 200 GB',
        storage_size: 'Desfrute de 1 TB de armazenamento',
        unlimited_review: 'Crie revisões ilimitadas',
      },
      cta_label: 'Obter desconto',
      dismiss_label: 'Agora não',
    },
    banner: {
      title:
        'Receba %{discount_amount}% de desconto no plano WeTransfer Pro por um ano, a nossa melhor oferta até agora',
      cta_label: 'Fazer upgrade',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: 'Crie uma equipe para transferir com %{first_recipient_email}',
      subtitle:
        'Convide sua equipe para enviar e receber transferências no seu plano %{user_plan}.',
      list: {
        overview_item: 'Vista geral compartilhada das transferências',
        storage_limit_item:
          'Armazenamento compartilhado de %{storage_limit} extras por pessoa',
        branding_item: 'Identidade visual de equipe compartilhada',
        subscription_item: 'Assinatura e faturamento compartilhados',
      },
      cta: 'Convidar equipe',
      dismiss_button: 'Hoje não',
    },
    second_viewing: {
      title: 'Team up on transfers with ${first_recipient_email}',
      subtitle:
        'Convide sua equipe para enviar e receber transferências no seu plano %{user_plan}.',
      list: {
        overview_item: 'Vista geral compartilhada das transferências',
        storage_limit_item:
          'Armazenamento compartilhado de %{storage_limit} extras por pessoa',
        branding_item: 'Identidade visual compartilhada',
        subscription_item: 'Assinatura e faturamento compartilhados',
      },
      cta: 'Convidar equipe',
      dismiss_button: 'Ocultar para sempre',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  custom_wallpaper: {
    set_custom_wallpaper: 'Definir papel de fundo personalizado',
    set_custom_wallpaper_description:
      'Coloque nessa transferência seu próprio papel de fundo para causar uma ótima impressão quando as pessoas baixarem seus arquivos. Não se preocupe, isto não mudará suas ',
    default_settings: 'configurações padrão',
    upload: 'Carregar',
    reset_default: 'Voltar para o padrão',
    survey_link: 'Conte-nos sua opinião',
    file_rules:
      'JPEG/PNG %{minWallpaperWidth}x%{minWallpaperHeight}, máximo de %{maxUploadSize} MB',
    storage_size_max: 'máximo',
    pop_over: {
      new_feature: 'Novo recurso',
      try_now: 'Experimente agora',
      not_today: 'Hoje não',
      hide_forever: 'Ocultar para sempre',
      hint: 'Ei, você pode colocar seu próprio papel de fundo em qualquer transferência sem alterar essas configurações. Basta definir um papel de fundo personalizado antes de enviar a transferência.',
      introductory_upsell:
        'Ei, agora você pode colocar seu próprio papel de fundo nesta transferência.',
    },
  },
  notification: {
    update_account: 'Sua conta foi atualizada',
    update_password: 'Sua senha foi alterada',
    update_subscription: 'O seu plano de pagamento foi atualizado',
    update_profile_success: 'O seu perfil foi atualizado',
    link_copied: 'Este link foi copiado para sua área de transferência',
    copy_link_manual: 'Link selecionado – copie com %{shortcut}',
    delete_transfer_success: 'Esta transferência foi excluída',
    delete_transfers_success: 'As transferências foram excluídas',
    update_expiry_success: 'A data de expiração foi atualizada',
    onboarding_success:
      'Veja aqui o resumo das transferências, contatos, identidade visual e outras informações',
    add_contact_success: 'Este contato foi adicionado',
    edit_contact_success: 'Este contato foi atualizado',
    remove_contact_success: 'Este contato foi excluído',
    already_signed_in: 'Você está conectado',
    cancel_subscription_success:
      'Que pena que você vai embora. Sua assinatura foi cancelada.',
    collect_app_banner_desc:
      'Veja a prévia, salve e gerencie arquivos a partir da Collect App',
    contact_added_confirmation: 'O contato foi adicionado à sua transferência',
    contact_recipient_locked_text:
      'O objetivo desta página é o recebimento de arquivos para o proprietário. Deseja enviar para outra pessoa?',
    forward_ready: 'Sua transferência está pronta para ser encaminhada',
    mobile_app_banner_desc: 'Veja a prévia, salve e gerencie arquivos no app',
    mobile_app_banner_title: 'Salvar no app',
    reactivate_subscription_success:
      'Bem-vindo de volta! Sua conta foi reativada. ',
    refresh_transfer_upload_lost: 'Deseja mesmo cancelar o carregamento atual?',
    update_payment_success:
      'Seus dados de pagamento foram atualizados com sucesso. Pronto!',
    update_user: 'Seus dados foram atualizados',
    current_team_notification:
      'Você está usando %{plan} na conta da equipe %{currentTeam}',
    display_name_updated: 'Título atualizado!',
    download_started:
      'O download já começou. Uma vez concluído, os arquivos estarão no seu computador (normalmente, na pasta de downloads).',
    logged_out:
      'Parece que você foi desconectado a partir de outro navegador. Conecte-se novamente.',
    project_delete:
      'Excluir <strong>%{projectName}</strong> e todos os arquivos que você adicionou ao mesmo?',
    project_delete_success: '<strong>%{projectName}</strong> foi apagado',
    password_changed: 'Senha alterada',
    password_removed: 'Senha removida',
  },
  alert: {
    confirm_cancel_upload_image: 'Deseja mesmo cancelar o carregamento atual? ',
    cancel_recipient_locked: 'Cancelar',
    cancel_refresh_transfer_upload_lost: 'Não',
    confirm_refresh_transfer_upload_lost: 'Sim',
    go_to_transfer: 'Ir para a transferência',
    redirect_recipient_locked: 'Sim',
    stay: 'Ficar',
    cancel_project_delete: 'Cancelar',
    confirm_project_delete: 'Excluir',
  },
  force_update:
    'Temos novidades interessantes! <a href="/" onClick=\'javascript:window.location.reload();\'>Atualize seu navegador</a> para ter certeza de que está usando a última versão do WeTransfer',
  user: {
    already_logged_in:
      'Você já está conectado. Deseja mesmo redefinir sua senha?',
    roles: {
      admin: 'administrador',
      owner: 'proprietário',
      user: 'usuário',
    },
    sign_out_and_reset: 'Sair e redefinir senha',
  },
  click_here: 'Clique aqui',
  cookiebox: {
    notice:
      '<bold>Você está conectado</bold> e será desconectado quando apagar os cookies. As transferências feitas na sua conta não serão afetadas.',
  },
  notice: {
    general_issues:
      'O funcionamento não está como deveria? Sabemos que é frustrante, mas aguarde mais um pouco, tudo vai voltar a funcionar <a target="_blank" href=%{link}>em breve</a>',
    transfer_issues:
      'Está enfrentando problemas com a sua transferência? Sabemos que é frustrante, mas aguarde mais um pouco, tudo vai voltar a funcionar <a target="_blank" href=%{link}>em breve</a>',
    verification:
      'Olá, precisamos que <a href="/account">confirme o seu e-mail</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Sobre | WeTransfer',
      advertise: 'Anuncie conosco | WeTransfer',
      apps: 'Apps gratuitos para Mac, iOS e Android | Apps WeTransfer',
      forgot_password: 'Redefina sua senha | WeTransfer Pro',
      help: 'Como enviar arquivos grandes | Ajuda do WeTransfer',
      home: 'Transfira arquivos grandes de forma fácil e gratuita | WeTransfer',
      plus: 'Faça um upgrade para enviar arquivos maiores | WeTransfer Pro',
      sign_in: 'Acessar | WeTransfer Pro',
      sign_up: 'Inscreva-se | WeTransfer Pro',
      upgrade: 'Faça um upgrade | WeTransfer Pro',
      pricing:
        'Preços | WeTransfer — Enviar arquivos grandes e compartilhar fotos online — Grátis até 2 GB',
    },
    descriptions: {
      help: 'Precisa de suporte técnico da WeTransfer? Veja como enviar arquivos grandes na nossa seção de ajuda rápida ou entre em contato conosco.',
      social_help: 'Ainda não encontrou o que está procurando?',
    },
  },
  splash: {
    footer: {
      or: 'ou',
      send_files: 'Só quero enviar meus arquivos',
      no_thanks: 'Não, obrigado',
    },
    heading: {
      line_1_free: 'A WeTransfer é a melhor forma para enviar arquivos grandes',
      line_2_free: 'Aproveite mais o WeTransfer',
      free_account: 'Bem-vindo de volta. Quer oficializar este acontecimento?',
    },
    plan: {
      plus: {
        feature_10: 'Personalize seus e-mails',
        feature_11: 'Armazene até %{plus_storage_limit}',
        feature_12: 'Decida quando as transferências expiram',
        feature_13: 'Proteja suas transferências com uma senha',
        feature_7: 'Personalize o seu perfil',
        feature_8: 'Crie sua própria agenda de endereços',
        feature_9: 'Personalize seu URL do WeTransfer',
      },
      free_account: {
        cta: 'Inscreva-se gratuitamente',
        feature_1: 'Sem armazenamento',
        feature_2: 'Envie até %{free_transfer_limit}',
        feature_3: 'Reenvie e exclua transferências',
        heading: 'Conta WeTransfer',
        price_label: 'Grátis para sempre',
      },
      pro: {
        cta: 'Adquira o WeTransfer Pro',
        feature_1: '%{storage_limit_pro} de armazenamento',
        feature_2: 'Envie e receba até %{transfer_limit_pro}',
        feature_2_unlimited: 'Envie e receba arquivos sem limites de tamanho',
        feature_3: 'Reenvie e exclua transferências',
        feature_4: 'Proteger as transferências com senha',
        feature_5: 'Sua página e endereço Pro próprios',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: 'Quer adicionar %{recipient} à sua equipe?',
      text_content:
        'Os membros da equipe podem acessar as transferências uns dos outros com armazenamento e identidade visual compartilhados. Isto não cancela a sua transferência.',
      cta: 'Vamos lá',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Link copiado',
      copy: 'Copiar link',
      copy_again: 'Copiar novamente',
    },
    labels: {
      share: 'Compartilhar esta transferência',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'DICA PRO',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Experimente os portais',
        dismiss: 'Agora não',
        text: 'Você pode convidar clientes e colaboradores para verem o seu trabalho e selecionarem os favoritos deles com os <strong>portais</strong>. Assim evitamos e-mails desnecessários.',
        title: 'Precisa de opiniões rápidas sobre o seu trabalho?',
      },
      'second-viewing': {
        cta: 'Experimente os portais agora',
        dismiss: 'Não exibir novamente',
        text: 'Receba opiniões rapidamente e compartilhe novas versões, tudo no mesmo lugar. Com os <strong>portais</strong>, você garante a passagem do trabalho sem percalços, da avaliação para a revisão até à entrega final.',
        title: 'Você enviou o trabalho. E agora?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Vá para a identidade visual',
        text_2: 'Quer adicionar seus próprios vídeos ou imagens?',
      },
      individual: {
        cta: 'Configure a página',
        text: 'Deixe uma excelente impressão sempre que as pessoas baixarem seus arquivos. Adicione vídeos ou imagens e escolha o seu próprio URL.',
        title: 'Prepare o cenário com sua página própria no WeTransfer',
      },
      invitee: {
        cta: 'Entendi',
        text_1:
          'Com a página personalizada do WeTransfer para a sua equipe, você vai deixar uma excelente impressão sempre que compartilhar seu trabalho.',
        text_2:
          'Você pode alterar os fundos de tela da sua equipe sempre que quiser na opção <strong>Identidade visual</strong>.',
        title: 'Exiba seu trabalho (da sua equipe)',
      },
      not_now: 'Agora não',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Configure a página',
                  premium: {
                    text: 'Qualquer pessoa pode enviar transferências de qualquer tamanho para você na página do WeTransfer da sua equipe.',
                  },
                  text: 'Qualquer pessoa pode enviar %{transfer_limit_pro} transferências para você na página do WeTransfer da sua equipe',
                },
                premium: {
                  transfer_link: {
                    text: 'Qualquer pessoa pode enviar transferências de qualquer tamanho para você de %{custom_link}',
                  },
                },
                transfer_link: {
                  text: 'Qualquer pessoa pode enviar %{transfer_limit_pro} transferências para você de %{custom_link}',
                },
              },
              premium: {
                text: 'Qualquer pessoa pode enviar transferências de qualquer tamanho para você na página do WeTransfer da sua equipe, basta compartilhar este link com ela.',
              },
              regular: {
                cta: 'Entendi',
                text: 'Qualquer pessoa pode enviar <strong>%{transfer_limit_pro}</strong> transferências para você na página do WeTransfer da sua equipe, basta compartilhar este link com ela.',
                title: 'Um só lugar para tudo o que a sua equipe recebe',
              },
            },
            sent: {
              regular: {
                cta: 'Entendi',
                text: 'Este é o resumo compartilhado das transferências enviadas pela sua equipe. Agora, você pode monitorar os downloads, modificar as datas de validade e até mesmo modificar ou excluir as transferências de outra pessoa. Mas avise antes para não magoar ninguém!',
                title: 'Gerencie as transferências da sua equipe',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'Agora o WeTransfer Plus é WeTransfer Pro com 1 TB de espaço. São 10x mais. <a href="/transfers">Venha conhecer.</a>',
  },
  refer_friend: {
    title: 'Indique amigos',
    account: {
      description:
        'Você e os seus amigos vão receber US 10 cada um quando se inscreverem no WeTransfer Pro ou Premium. Compartilhe o link de indicação para receber prêmios em cartões pré-pagos, doações beneficentes ou vales-presente de centenas de parceiros.',
    },
    window: {
      link: 'Pegue o link de indicação',
      send_another: 'Continuar',
      text: 'Você e os seus amigos vão receber <strong>US$ 10</strong> cada um quando se inscreverem no WeTransfer Pro ou Premium.',
      title: 'Indique um amigo',
      title_2: 'para enviar transferências.',
    },
    message: {
      success:
        'Tens aqui uma excelente amizade! Inscreva-se no WeTransfer Pro ou Premium e ambos receberão um cartão pré-pago, donativos para caridade ou vales presente no valor de $ 10.',
      self: 'O link de indicação não está correto. Peça um novo link ao seu amigo para receber US$ 10 quando se inscrever no WeTransfer Pro ou Premium.',
      fallback:
        'O link de indicação não está correto. Peça um novo link ao seu amigo para receber US$ 10 quando se inscrever no WeTransfer Pro ou Premium.',
      expired: 'O link de indicação expirou.',
      dismiss: 'Ignorar',
    },
  },
  order_summary: {
    coupon: {
      link: 'Aplicar código promocional',
      input_placeholder: 'Código promocional',
      button_label: 'Aplicar',
      error_message:
        'Desculpe, mas este código só pode ser usado para economizar na assinatura de %{billing_period}.',
      generic_error_message:
        'Desculpe, mas este código não é compatível com esta assinatura',
      input_error_message: 'Bem, este código não é válido.',
      pill_label: {
        percentage: '-%{percentage}%',
      },
    },
    total: 'Total',
  },
  mobile_verify: {
    title: 'Já está tudo pronto',
    subtitle:
      'O seu e-mail foi verificado. Agora você pode utilizar o app para enviar e receber transferências.',
    cta: 'Abrir o app WeTransfer',
  },
  profile_and_security: {
    page_name: 'Perfil e segurança',
    profile_title: 'Perfil',
    security_title: 'Segurança',
  },
  team_settings: {
    title: 'Configurações da equipe',
  },
  branded_page: {
    title: 'Branded page',
  },
  branded_emails: {
    title: 'Branded emails',
  },
  upgrade_workspace: {
    title: 'Get more from your workspace',
    upgrade_text:
      'To set up your <b>branded page and emails</b>, and <b>invite members</b> to your workspace you will need to upgrade.',
    pro_information:
      'With a Pro subscription, you can also <b>set passwords</b> and expiration dates on your transfers, <b>send and receive up to 200 GB</b> at a time, and <b>store up to 1 TB</b> per member.',
    cta: 'Upgrade',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Seu plano atual de <b>%{formattedintervaltotal}</b>/%{subscriptioninterval} será renovado automaticamente em <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'Seu plano atual de <b>%{formattedTeamWorkspaceCost}</b>/%{subscriptioninterval} (%{membercount} x %{tieramount}) será renovado automaticamente em <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'Sua próxima data de pagamento é <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b>/%{interval}',
    team_upgrade_calculation_one: '(%{membercount} member x %{tierprice})',
    team_upgrade_calculation_multiple:
      '(%{membercount} members x %{tierprice})',
    pro_card_cta: 'View full benefits',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Transferências sem limite de tamanho',
    premium_feature_two: 'Armazenamento ilimitado',
    premium_feature_three: 'Portais e avaliações ilimitados',
    premium_feature_four:
      'Ver <a class="all-benefits-link" href="%{all_benefits_href}">todos os benefícios</a>',
    premium_switch_cta_text: 'Mudar para o Premium',
    pill_text: 'Plano atual',
    member_count: '%{membercount} membros',
    see_all_benefits: 'Ver todos os benefícios do plano',
    pending_downgrade_current_subscription:
      'A assinatura do espaço de trabalho foi cancelada e terminará em <b>%{cancellation_date}</b>.',
    pending_downgrade_reactivate_text:
      'Mudou de ideia? Não entre em pânico. É fácil reestabelecer tudo.',
    pending_downgrade_reactivate_cta: 'Reativar a assinatura',
    pending_downgrade_payment: 'Não há novos pagamentos',
    update_payment_cta: 'Atualizar dados de pagamento',
    cancel_plan:
      'Se você cancelar a assinatura, poderá acessar seu espaço de trabalho do %{planName} até %{subscriptionRenewalDate}. ',
    cancel_expiry_text:
      'Depois, seu espaço de trabalho sofrerá downgrade para o plano gratuito e as transferências existentes vão expirar após 28 dias.',
    pending_payment_text:
      'Para ver informações sobre o seu plano e de pagamento, efetue o pagamento ou cancele o pedido.',
    learn_more: 'Saiba mais sobre os planos e preços',
    team_upgrade_calculation: '(%{membercount} membros x %{tierprice})',
  },
  time: {
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    remaining: {
      minutes: {
        zero: 'Under a minute remaining',
        one: 'About 1 minute remaining',
        other: 'About %{count} minutes remaining',
      },
      hours: {
        one: 'About an hour remaining',
        other: 'About %{count} hours remaining',
      },
    },
  },
  download: {
    shortcut: 'Press %{command} to see the<br />download progress',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Send up to %{size}',
    progress: {
      busy: 'Transferring...',
    },
    buttons: {
      add: 'Add files',
      transfer: 'Transfer',
      forward: 'Forward',
    },
    forward: {
      done: 'Forward complete',
    },
    friend_email: {
      title: "Friend's email",
      more: 'Add more friends',
    },
    your_email: {
      title: 'Your email',
    },
    message: {
      title: 'Message',
    },
    done: {
      title: 'Transfer complete',
      link: 'Copy your download link:',
      copied: {
        title: 'Copied!',
        text: 'The download link has been copied.',
      },
    },
    more_html: 'Add more files<span>(%{size} left)</span>',
    too_many_recipients:
      "Seems like you've entered too many email addresses. Remember: there's room for up to %{count} people at a time.",
    completed: '%{size} of %{total} completed',
    addresses: {
      one: '%{count} address',
      other: '%{count} addresses',
      remove: 'Do you want to remove %{address} from your previous recipients?',
    },
    ads: {
      plus: {
        title: 'Get more out<br />of WeTransfer<br />with Pro',
        text: "<ul><li>Supersized uploads</li><li>Personalised transfers with your own backgrounds</li><li>Password protected transfers</li><li>Long term storage</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus2: {
        title: 'Impress<br />with your<br />own custom download page',
        text: "<p>Use your own backgrounds and custom WeTransfer URL (yourname.wetransfer.com)<br />to impress your recipients.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus3: {
        title: 'Manage<br />your transfers smarter',
        text: "<p>This transfer is deleted after a week, but with WeTransfer Pro you can store indefinitely, resend and delete instantly, without having to upload again.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus4: {
        title: 'Get extra protection<br />for your files',
        text: "<p>With WeTransfer Pro, you can protect your important and confidential files with a password.</p><p>That way they will never fall into the wrong hands.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      facebook: {
        title: 'Join the<br />WeTransfer<br />community<br />on Facebook',
        text: "<p>Get the latest news, win prizes, discover new artists, read interviews and much more.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Find out more</a></p>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email: 'Sorry, only email is supported when resending a transfer.',
      connect_twitter:
        'Your Twitter account is not yet connected to WeTransfer.',
      connect_facebook:
        'Your Facebook account is not yet connected to WeTransfer.',
      transferproblems: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      limitreached: {
        title: 'Storage Limit',
        text: 'You reached your 1 TB limit. Delete some old transfers to send new files',
      },
      blocked: {
        title: 'Transfer problem',
        text: 'Computer says no. Sorry, but you have been blocked from WeTransfer.',
      },
      upload_error: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      unavailable: {
        title: 'Transfer error',
        text: 'Sorry, this transfer has already been deleted so it cannot be forwarded.',
      },
      startswithdot: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a full stop. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      startswithspace: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a space. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      containsreturn: {
        title: 'Oops',
        text: "One (or more) of your files has a name that contains a return. We don't know quite how you've done that, but it's not going to work. Please rename the file(s), and try adding them again.",
      },
      alreadyinlist: {
        title: 'Yikes',
        text: "Turns out one of your files had the same name as another file that you've already selected. Change it up a little!",
      },
      transfertoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      filetoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      zerobytes: {
        title: 'Whoops',
        text: 'One (or more) of your files is empty or could not be read.',
      },
      ioerror: {
        title: 'Fail',
        text: "One (or more) of your files could not be read or is larger than %{upload_limit}GB. That's not going to fly.",
      },
      filenametoolong: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that is longer than 250 characters. We can't accept filenames longer than this, so please rename it.",
      },
      nofolders: {
        title: 'Uh-oh',
        text: "Sorry, uploading folders doesn't work yet. Try zipping it first.",
      },
      nofiles: {
        title: 'Oops',
        text: "You haven't actually added any files yet.",
      },
      norecipients: {
        title: 'Doh!',
        text: 'Looks like you forgot to enter any email addresses to send to.',
      },
      toomanyrecipients: {
        title: 'Yikes',
        text: 'Too many recipients.',
      },
      bigmessage: {
        title: 'Oops',
        text: 'Your message is longer than a novel. Please make it shorter.',
      },
      nosender: {
        title: 'Seriously?',
        text: 'You forgot to enter your own email address. How could you?',
      },
      senderemailinvalidformat: {
        title: 'Uh-oh',
        text: 'Your email address appears to be incorrect. Mind your spelling!',
      },
      probablynotcopied: {
        title: 'Oops',
        text: "It looks like you haven't copied the link.",
      },
      recipientemailinvalidformat: {
        title: 'Oops',
        text: "You entered one of your friend's email addresses incorrectly.",
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that contains a backslash. We can't accept this, so please rename the files so they don't contain the backslash.",
      },
    },
    tips: {
      maxfilesize_tip: {
        title: 'Tip',
        text: "You can send up to 2GB per transfer. And what's even better: you can transfer as often as you like.",
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Important',
        text: "Your Pro account can send up to 20 GB per transfer, but your browser is preventing this. <a href='/questions/33'>Click here for more information</a>",
      },
      recipients_tip: {
        title: 'Tip',
        text: 'You can enter up to %{email_limit} email addresses to send to. If you just want a download link, click on the share button below.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Tip',
        text: 'Pop your own email address in here so we can contact you when the files have been downloaded.',
      },
      expire_tip: {
        title: 'Tip',
        text: 'You can now change the expiry date of your Pro transfers.',
      },
      message_tip: {
        title: 'Tip',
        text: "Want to send your friends a message along with the files? Here's your chance - but you don’t have to.",
      },
      share_tip: {
        title: 'Tip',
        text: 'Change the way you share your files. Send them by email or grab a download link.',
        text_plus:
          'Change the way you share your files. Send them by email, Twitter, Facebook, or grab a download link.',
      },
      download: {
        title: '',
        chrome:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The download progress should be visible at the bottom of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out how to change this behaviour here</a>.",
        firefox:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in your browser's Download window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        safari:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in the top right corner of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        old_explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. You may also see a security alert at the top of the browser window. <a href='/questions/24' target='_blank'>Find out more</a>.",
        explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible at the bottom of your browser window (you may need to click on Save first), and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        settings:
          'You can change your default download location in your browser settings.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding: 'Forwarding this transfer will clear the form, are you sure?',
    is_busy: "Sorry, we can't do this right now",
  },
  mobile_app: {
    remember_choice: "Don't show this message again",
    uploader: {
      description:
        'Our site is not optimised for mobile right now. But we do have a shiny mobile app.',
      app_name: 'WeTransfer',
      download: 'Download the App',
      continue: 'Continue to WeTransfer.com',
    },
    downloader: {
      title: 'Your files are ready for download!',
      description_ios:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a>" is a pretty good app for that.',
      description_android:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a>" is a pretty good app for that.',
      continue: 'Understood',
    },
  },
};
